<template>
  <page-content
    :has-left-col-xsmall="true"
    :has-sticky-col-left="true"
    :has-padd-right-normal="true"
    :set-main-col-class="''">
    <template slot="left-col-small">
      <aside class="menu menu--admin">
        <ul class="menu-list has-background-white is-border">
          <li class="is-active">
            <a @click="panel = 'ADMINISTRATIF'">Information {{ nameToUse }}</a>
            <ul>
              <li
                :class="{'is-active' : panel === 'ADMINISTRATIF'}"
                id="tabs-ADMINISTRATIF">
                <a @click="panel = 'ADMINISTRATIF'">
                  <div class="is-uppercase">Administratif</div>
                </a>
              </li>
              <li
                :class="{'is-active' : panel === 'FICHE_PROGRAMME'}"
                id="tabs-FICHE_PROGRAMME">
                <a @click="panel = 'FICHE_PROGRAMME'">
                  <div class="is-uppercase">Fiche {{ nameToUse }}</div>
                </a>
              </li>
              <li
                :class="{'is-active' : panel === 'DOCS'}"
                id="tabs-DOCS">
                <a
                  :class="{'is-disabled' : newProgram}"
                  @click="!newProgram ? panel = 'DOCS' : null">
                  <div class="is-uppercase">Documentation</div>
                </a>
              </li>
              <li
                :class="{'is-active' : panel === 'APPEL_DE_FOND'}"
                id="tabs-APPEL_DE_FOND">
                <a
                  :class="{'is-disabled' : newProgram}"
                  @click="!newProgram ? panel = 'APPEL_DE_FOND' : null">
                  <div class="is-uppercase">Appel de fonds</div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </aside>
    </template>
    <div
      id="programEdit">
      <spinner-round
        :is-loading="loading"
        v-if="loading"></spinner-round>
      <form
        @submit.prevent.stop=""
        v-if="program">
        <div
          class="has-background-white is-border"
          v-show="panel === 'ADMINISTRATIF'">
          <div class="columns is-gapless has-background-warning is-marginless">
            <div class="is-size-7 is-padding">
              <span class="icon is-small is-margin-right-xxsmall has-text-success">
                <i class="fas fa-check-circle"></i>
              </span>
              <span class="is-uppercase has-text-weight-bold">INFORMATION NÉCESSAIRE À LA VALIDATION DE LA FICHE ADMINISTRATIVE</span>
            </div>
          </div>
          <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
            <div class="is-size-5 is-uppercase">
              Données {{ nameToUse }}
            </div>
          </div>
          <div class="has-background-white--darken1 is-padding">
            <div class="columns is-multiline">
              <div class="column is-6">
                <r-label
                  :label="'Nom du ' + nameToUse"
                  :value="program.name"
                  :red-check="hasCheck"></r-label>
                <div class="control">
                  <v-input
                    id="name"
                    name="name"
                    @input="updateValue($event, 'name')"
                    :model="program.name"
                    v-validate="'required|min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    :data-vv-as="'Nom du ' + nameToUse">
                  </v-input>
                </div>
              </div>
              <div
                class="column is-3"
                v-if="isDistributeur">
                <r-label
                  label="Promoteur"
                  :red-check="hasCheck"
                  :value="program.promoteur_name"></r-label>
                <div class="control">
                  <multiselect
                    v-model="promoteur"
                    id="promoteur"
                    label="name"
                    track-by="name"
                    :options="promoteurs"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    @search-change="getPromoteurs"
                    :placeholder="''"
                    class="multiselect--option-ico"
                    :value="program.promoteur_name">
                    <template
                      slot="clear"
                      slot-scope="props">
                      <div
                        class="multiselect__clear"
                        v-if="promoteurs.length"
                        @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                    <span
                      slot="placeholder"
                      class="multiselect__placeholder">{{ program.promoteur_name || 'Sélectionnez ou saisissez un promoteur' }}</span>
                    <span slot="noOptions">La liste est vide</span>
                  </multiselect>
                </div>
              </div>
              <div
                class="column"
                style="flex: none; width: 21%;">
                <r-label
                  label="N° référence"
                  :red-check="false"
                  :is-required="false"
                  :value="program.ref"></r-label>
                <div class="control">
                  <v-input
                    id="ref"
                    name="ref"
                    @input="updateValue($event, 'ref')"
                    :model="program.ref"
                    placeholder="Minimum quatre caractères"
                    v-validate="'min:4'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="N° référence">
                  </v-input>
                </div>
              </div>
              <div
                class="column"
                style="flex: none; width: 21%; margin-left: 0.5rem;">
                <r-label
                  label="Agence principale"
                  :red-check="false"
                  :is-required="false"
                  :value="program.main_agence ? program.main_agence.name : null"></r-label>
                <div class="control">
                  <multiselect
                    :value="program.main_agence"
                    id="main_agence"
                    class="multiselect--input-size"
                    label="name"
                    track-by="pk"
                    :options="agences"
                    :searchable="true"
                    :internal-search="false"
                    :close-on-select="true"
                    :show-labels="false"
                    :allow-empty="true"
                    @open="getAgences()"
                    @search-change="getAgences"
                    @input="updateValue($event, 'main_agence')"
                    placeholder="Rechercher une agence">
                    <span slot="noResult">Oups! Aucune agence trouvée.</span>
                    <span slot="noOptions">La liste est vide</span>
                  </multiselect>
                </div>
              </div>
              <div
                v-if="isSage || isSageConnector"
                class="column is-2">
                <r-label
                  label="Société"
                  :red-check="false"
                  :is-required="false"
                  :value="program.society"></r-label>
                <div class="control">
                  <v-input
                    id="society"
                    name="society"
                    @input="updateValue($event, 'society')"
                    :model="program.society"
                    placeholder="Minimum quatre caractères"
                    v-validate="'min:4'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Société">
                  </v-input>
                </div>
              </div>
              <div class="column is-12">
                <address-input
                  :source="program.address"
                  :is-required="true"
                  :red-check="hasCheck"
                  @update="updateAddress">
                </address-input>
              </div>
              <div v-if="program.is_amenagement">
                <div class="column is-3">
                  <r-label
                    label="Type d'opération"
                    :red-check="false"
                    :is-required="false"
                    :value="program.operation_type"></r-label>
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select
                        v-model="program.operation_type"
                        id="operation">
                        <option :value="null">
                          Selectionnez un type
                        </option>
                        <option
                          v-for="c in filteredOperationTypeList"
                          :value="c.value"
                          :key="c.value"
                          :id="c.value">
                          {{ c.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-5">
                <r-label
                  label="Livraison"
                  :is-required="false"></r-label>
                <div class="control columns is-gapless">
                  <div class="select is-fullwidth">
                    <select v-model="deliveryQuarter">
                      <option :value="null">
                        Trimestre
                      </option>
                      <option
                        v-for="(t, i) in quarters"
                        :value="i + 1"
                        :key="i">
                        {{ t[i + 1] }}
                      </option>
                    </select>
                  </div>
                  <div class="select is-fullwidth is-margin-left">
                    <select v-model="deliveryYear">
                      <option :value="null">
                        Année
                      </option>
                      <option
                        v-for="year in years"
                        :value="year"
                        :key="year">
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column is-1"></div>
              <div class="column is-5">
                <r-label
                  label="Actabilité"
                  :is-required="false"></r-label>
                <div class="control columns is-gapless">
                  <div class="select is-fullwidth">
                    <select v-model="actabilityQuarter">
                      <option :value="null">
                        Trimestre
                      </option>
                      <option
                        v-for="(t, i) in quarters"
                        :value="i + 1"
                        :key="i">
                        {{ t[i + 1] }}
                      </option>
                    </select>
                  </div>
                  <div class="select is-fullwidth is-margin-left">
                    <select v-model="actabilityYear">
                      <option :value="null">
                        Année
                      </option>
                      <option
                        v-for="year in years"
                        :value="year"
                        :key="year">
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="is-padding has-background-light">
            <div class="columns is-multiline">
              <div class="column is-12 title is-5 is-uppercase is-marginless-bottom">
                <b>Terrain - Permis de construire</b>
              </div>
              <div class="column is-4">
                <r-label
                  label="Référence cadastrale"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.construction_data.reference_cadrastrale"></r-label>
                <div class="control">
                  <v-input
                    id="reference_cadrastrale"
                    name="reference_cadrastrale"
                    @input="updateValue($event, 'construction_data', 'reference_cadrastrale')"
                    :model="program.construction_data.reference_cadrastrale"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Référence cadastrale">
                  </v-input>
                </div>
              </div>
              <div class="column is-4">
                <r-label
                  label="Superficie terrain (en m2)"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.construction_data.surface_terrain"></r-label>
                <div class="control">
                  <v-input
                    id="surface_terrain"
                    name="surface_terrain"
                    @input="program.construction_data.surface_terrain = $event"
                    :number="true"
                    :model="program.construction_data.surface_terrain"
                    :errors-bag="errors"
                    input-type="number"
                    :three-space="true"
                    v-validate="'decimal:2'"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Superficie terrain (en m2)">
                  </v-input>
                </div>
              </div>
              <div class="column"></div>
              <div class="column is-4">
                <r-label
                  :label="'Numéro de ' + permisToUse"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.construction_data.num_pc"></r-label>
                <div class="control">
                  <v-input
                    id="num_pc"
                    name="num_pc"
                    @input="updateValue($event, 'construction_data', 'num_pc')"
                    :model="program.construction_data.num_pc"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    :data-vv-as="'Numéro de ' + permisToUse">
                  </v-input>
                </div>
              </div>
              <div class="column is-4">
                <r-label
                  label="Délivré par :"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.construction_data.construction_licence_author"></r-label>
                <div class="control">
                  <v-input
                    id="construction_licence_author"
                    name="construction_licence_author"
                    @input="updateValue($event, 'construction_data', 'construction_licence_author')"
                    :model="program.construction_data.construction_licence_author"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Délivré par :">
                  </v-input>
                </div>
              </div>
              <div class="column is-4">
                <date-picker
                  :model="program.construction_data.construction_licence_date"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :style-version="2"
                  @input="updateValue($event, 'construction_data', 'construction_licence_date')"
                  label="Date d'autorisation du permis"></date-picker>
              </div>
              <div
                class="column is-4"
                v-if="program.is_amenagement">
                <date-picker
                  :model="program.construction_data.deadline_pc_date"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :style-version="2"
                  @input="updateValue($event, 'construction_data', 'deadline_pc_date')"
                  label="Date butoir de dépôt PC"></date-picker>
              </div>
              <div class="column is-4">
                <template
                  v-if="(lotLoading === true || editLotPath === true) && createProgPath === false">
                  <r-label
                    label="Nombre total de parcelles"
                    :is-required="hasCheck"
                    :red-check="hasCheck"
                    :value="program.construction_data.total_lots"></r-label>
                </template>
                <template
                  v-else-if="(programLoading === true || createProgPath === true) && editLotPath === false">
                  <r-label
                    label="Nombre total de logements"
                    :is-required="hasCheck"
                    :red-check="hasCheck"
                    :value="program.construction_data.total_lots"></r-label>
                </template>
                <div class="control">
                  <v-input
                    id="total_lots"
                    name="total_lots"
                    @input="updateValue($event, 'construction_data', 'total_lots')"
                    :model="program.construction_data.total_lots"
                    input-type="number"
                    :number="true"
                    :three-space="true"
                    v-validate="'decimal:0'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Nombre total de logement">
                  </v-input>
                </div>
              </div>
              <div class="column is-4">
                <r-label
                  label="Surface de plancher (en m2)"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.construction_data.surface_plancher"></r-label>
                <div class="control">
                  <v-input
                    id="surface_plancher"
                    name="surface_plancher"
                    @input="updateValue($event, 'construction_data', 'surface_plancher')"
                    :model="program.construction_data.surface_plancher"
                    input-type="number"
                    :number="true"
                    :three-space="true"
                    v-validate="'decimal:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Surface du plancher en m2">
                  </v-input>
                </div>
              </div>
              <div class="column is-4">
                <r-label
                  label="Nombre total de parking"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.construction_data.total_parking"></r-label>
                <div class="control">
                  <v-input
                    id="total_parking"
                    name="total_parking"
                    @input="updateValue($event, 'construction_data', 'total_parking')"
                    :model="program.construction_data.total_parking"
                    input-type="number"
                    :number="true"
                    :three-space="true"
                    v-validate="'decimal:0'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Nombre total de parking">
                  </v-input>
                </div>
              </div>
              <div class="column is-6">
                <r-label
                  label="Aménagements prévus (séparer par une virgule)"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.construction_data.planned_developments"></r-label>
                <wysiwyg-editor
                  :model="program.construction_data.planned_developments"
                  :light-program="true"
                  :light="true"
                  @change="updateValue($event, 'construction_data', 'planned_developments')"
                  class="has-background-white" />
              </div>
              <div class="column is-4">
                <date-picker
                  :model="program.construction_data.pc_depose_date"
                  :is-required="false"
                  :style-version="2"
                  :red-check="hasCheck"
                  @input="updateValue($event, 'construction_data', 'pc_depose_date')"
                  :label="permisToUse + ' Déposé'"></date-picker>
              </div>
              <div class="column is-2 columns is-space-between is-column is-gapless is-marginless">
                <r-label
                  label="Étape validée"
                  :is-required="false"
                  :red-check="false"
                  :value="program.construction_data.pc_depose_validated"></r-label>
                <div>
                  <input
                    id="pc_depose_validated"
                    type="checkbox"
                    name="pc_depose_validated"
                    class="switch is-success is-rounded is-medium"
                    v-model="program.construction_data.pc_depose_validated">
                  <label
                    for="pc_depose_validated"
                    class="label"></label>
                </div>
              </div>
              <div class="column is-4">
                <date-picker
                  :model="program.construction_data.pc_purge_date"
                  :is-required="false"
                  :red-check="hasCheck"
                  :style-version="2"
                  @input="updateValue($event, 'construction_data', 'pc_purge_date')"
                  :label="permisToUse + ' Purgé'"></date-picker>
              </div>
              <div class="column is-2 columns is-space-between is-column is-gapless is-marginless">
                <r-label
                  label="Étape validée"
                  :is-required="false"
                  :red-check="false"
                  :value="program.construction_data.pc_purge_validated"></r-label>
                <div>
                  <input
                    id="pc_purge_validated"
                    type="checkbox"
                    name="pc_purge_validated"
                    class="switch is-success is-rounded is-medium"
                    v-model="program.construction_data.pc_purge_validated">
                  <label
                    for="pc_purge_validated"
                    class="label"></label>
                </div>
              </div>
              <div class="column is-4">
                <date-picker
                  :model="program.construction_data.gfa_obtenu_date"
                  :is-required="false"
                  :red-check="hasCheck"
                  :style-version="2"
                  @input="updateValue($event, 'construction_data', 'gfa_obtenu_date')"
                  label="GFA Obtenu"></date-picker>
              </div>
              <div class="column is-2 columns is-space-between is-column is-gapless is-marginless">
                <r-label
                  label="Étape validée"
                  :is-required="false"
                  :red-check="false"
                  :value="program.construction_data.gfa_obtenu_validated"></r-label>
                <div>
                  <input
                    id="gfa_obtenu_validated"
                    type="checkbox"
                    name="gfa_obtenu_validated"
                    class="switch is-success is-rounded is-medium"
                    v-model="program.construction_data.gfa_obtenu_validated">
                  <label
                    for="gfa_obtenu_validated"
                    class="label"></label>
                </div>
              </div>
              <div
                v-if="!program.use_tranche"
                class="column is-2">
                <div class="control columns is-gapless">
                  <div>
                    <r-label
                      label="Taux GFA"
                      :is-required="false"
                      :red-check="false"
                      :value="program.gfa_defined_percentage"></r-label>
                    <v-input
                      id="remuneration"
                      :name="'remuneration'"
                      :classes-input="'is-active is-input is-fullwidth'"
                      :has-incrementations="true"
                      input-type="number"
                      :has-addons="true"
                      @input="program.gfa_defined_percentage = $event"
                      :model="program.gfa_defined_percentage"
                      :min="1"
                      :max="100"
                      :step="1"
                      :number="true"
                      v-validate="'decimal:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as=" ">
                      <p
                        class="control"
                        slot="addonRight">
                        <a class="button is-border is-square is-static">
                          <span class="icon"><i class="fas fa-percentage"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
              </div>
              <div
                :class="!program.use_tranche ? 'is-margin-left-xsmall' : ''"
                class="column is-3 is-flex is-nowrap is-align-items-flex-end is-padding-bottom-small">
                <div class="control">
                  <input
                    id="show_gfa"
                    type="checkbox"
                    name="show_gfa"
                    v-model="program.program_params.show_gfa"
                    class="switch is-success is-rounded is-medium">
                  <label
                    for="show_gfa"
                    class="is-uppercase">
                    <span
                      v-if="program.program_params.show_gfa"
                      class="is-size-6 is-margin-top-xxsmall">Objectif GFA affiché</span>
                    <span
                      v-else
                      class="is-size-6 is-margin-top-xxsmall">Objectif GFA masqué</span>
                    &nbsp;
                    <span
                      class="is-margin-left-xsmall icon is-medium"
                      v-helper.bottom.small="'6G7yUdJ6esxp0TpYOPc2Dr'">
                      <i class="fal fa-question-circle has-text-grey"></i>
                    </span>
                  </label>
                </div>
              </div>
              <div class="column"></div>
              <div class="column is-6">
                <r-label
                  label="Prévisionnel début des travaux"
                  :is-required="false"></r-label>
                <div class="control columns is-gapless">
                  <div class="select is-fullwidth">
                    <select v-model="startWorkQuarter">
                      <option :value="null">
                        Trimestre
                      </option>
                      <option
                        v-for="(t, i) in quarters"
                        :value="i + 1"
                        :key="i">
                        {{ t[i + 1] }}
                      </option>
                    </select>
                  </div>
                  <div class="select is-fullwidth is-margin-left">
                    <select v-model="startWorkYear">
                      <option :value="null">
                        Année
                      </option>
                      <option
                        v-for="year in years"
                        :value="year"
                        :key="year">
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <r-label
                  label="Prévisionnel fin des travaux"
                  :is-required="false"></r-label>
                <div class="control columns is-gapless">
                  <div class="select is-fullwidth">
                    <select v-model="endWorkQuarter">
                      <option :value="null">
                        Trimestre
                      </option>
                      <option
                        v-for="(t, i) in quarters"
                        :value="i + 1"
                        :key="i">
                        {{ t[i + 1] }}
                      </option>
                    </select>
                  </div>
                  <div class="select is-fullwidth is-margin-left">
                    <select v-model="endWorkYear">
                      <option :value="null">
                        Année
                      </option>
                      <option
                        v-for="year in years"
                        :value="year"
                        :key="year">
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                class="column is-4"
                v-if="isAmenagement">
                <r-label
                  label="Caution dégradations"
                  :is-required="hasCheck && isAmenagement"
                  :red-check="hasCheck && isAmenagement"
                  :value="program.guaranteed_participation_fund"></r-label>
                <div class="control">
                  <v-input
                    :has-addons="true"
                    id="guaranteed_participation_fund"
                    name="guaranteed_participation_fund"
                    @click="selectedInput = 'ht'"
                    @input="updateValue($event, 'guaranteed_participation_fund')"
                    :model="program.guaranteed_participation_fund"
                    input-type="number"
                    v-validate="'decimal:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    :number="true"
                    :three-space="true"
                    data-vv-as="Caution dégradations">
                    <p
                      class="control"
                      slot="addonRight">
                      <a class="button is-static is-border">
                        <span class="icon"><i class="fas fa-euro-sign"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <div
                class="column is-4"
                v-if="isAmenagement">
                <r-label
                  label="Autre caution"
                  :is-required="hasCheck && isAmenagement"
                  :red-check="hasCheck && isAmenagement"
                  :value="program.other_degradation_deposit"></r-label>
                <div class="control">
                  <v-input
                    :has-addons="true"
                    id="other_degradation_deposit"
                    name="other_degradation_deposit"
                    @click="selectedInput = 'ht'"
                    @input="updateValue($event, 'other_degradation_deposit')"
                    :model="program.other_degradation_deposit"
                    input-type="number"
                    v-validate="'decimal:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    :number="true"
                    :three-space="true"
                    data-vv-as="Autre caution">
                    <p
                      class="control"
                      slot="addonRight">
                      <a class="button is-static is-border">
                        <span class="icon"><i class="fas fa-euro-sign"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <div
                class="column is-4"
                v-if="isAmenagement">
                <r-label
                  label="Caution conformité"
                  :is-required="hasCheck && isAmenagement"
                  :red-check="hasCheck && isAmenagement"
                  :value="program.fences_realisation"></r-label>
                <div class="control">
                  <v-input
                    :has-addons="true"
                    id="fences_realisation"
                    name="fences_realisation"
                    @click="selectedInput = 'ht'"
                    @input="updateValue($event, 'fences_realisation')"
                    :model="program.fences_realisation"
                    input-type="number"
                    v-validate="'decimal:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    :number="true"
                    :three-space="true"
                    data-vv-as="Caution conformité">
                    <p
                      class="control"
                      slot="addonRight">
                      <a class="button is-static is-border">
                        <span class="icon"><i class="fas fa-euro-sign"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <div
                class="column is-4"
                v-if="isAmenagement">
                <r-label
                  label="Installation compteur Eau"
                  :is-required="hasCheck && isAmenagement"
                  :red-check="hasCheck && isAmenagement"
                  :value="program.suez_installation"></r-label>
                <div class="control">
                  <v-input
                    :has-addons="true"
                    id="suez_installation"
                    name="suez_installation"
                    @click="selectedInput = 'ht'"
                    @input="updateValue($event, 'suez_installation')"
                    :model="program.suez_installation"
                    input-type="number"
                    v-validate="'decimal:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    :number="true"
                    :three-space="true"
                    data-vv-as="Installation compteur Eau">
                    <p
                      class="control"
                      slot="addonRight">
                      <a class="button is-static is-border">
                        <span class="icon"><i class="fas fa-euro-sign"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
            </div>
          </div>
          <div v-if="program.permis && program.permis.length">
            <div
              v-for="(permis, i) in program.permis"
              :key="'permis-'+ i"
              class="columns column is-12 is-multiline is-padding is-marginless"
              :class="i % 2 === 0 ? 'has-background-white' : 'has-background-light'">
              <div class="column is-3">
                <r-label
                  label="Type de permis"
                  :red-check="hasCheck"
                  :value="permis.permis_type"></r-label>
                <div class="control columns is-gapless">
                  <div class="select is-fullwidth">
                    <select v-model="permis.permis_type">
                      <option :value="null">
                        Choisissez un type de permis
                      </option>
                      <option
                        v-for="(type, j) in permisTypes"
                        :value="type.value"
                        :key="j + i">
                        {{ type.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column is-3">
                <r-label
                  label="Numéro"
                  :is-required="false"
                  :red-check="false"
                  :value="permis.numero"></r-label>
                <div class="control">
                  <v-input
                    :id="'permis_numero' + i"
                    name="permis_numero"
                    @input="permis.numero = $event"
                    :model="permis.numero"
                    input-type="text"
                    v-validate="''"
                    :errors-bag="errors"
                    data-vv-value-path="val">
                  </v-input>
                </div>
              </div>
              <div class="column is-3">
                <date-picker
                  :model="permis.date_deposit"
                  :is-required="false"
                  :style-version="2"
                  @input="permis.date_deposit = $event"
                  label="Date de dépôt du permis"></date-picker>
              </div>
              <div class="column is-2"></div>
              <div class="column is-1">
                <div class="is-margin-left-large">
                  <r-label
                    label="z"
                    :is-required="false"
                    :red-check="false"
                    style="opacity: 0"></r-label>
                  <a
                    @click="program.permis.splice(i, 1)"
                    class="button is-square is-grey is-border">
                    <span class="icon"><i class="fal fa-trash-alt fa-lg"></i></span>
                  </a>
                </div>
              </div>
              <div class="column is-3">
                <date-picker
                  :model="permis.date_obtaining"
                  :is-required="false"
                  :style-version="2"
                  @input="permis.date_obtaining = $event"
                  label="Date d'obtention du permis"></date-picker>
              </div>
              <div class="column is-3">
                <date-picker
                  :model="permis.date_purge"
                  :is-required="false"
                  :style-version="2"
                  @input="permis.date_purge = $event"
                  label="Date de purge du permis"></date-picker>
              </div>
            </div>
          </div>
          <div
            @click="addNewPermis"
            class="columns is-gapless w100">
            <div
              class="column w100 has-text-centered is-padding is-margin-small is-border is-border--dashed columns is-gapless is-vcentered is-centered has-background-light">
              <div class="column file-label">
                <span class="is-uppercase">Ajouter un permis&nbsp;</span>
                <b class="is-uppercase is-underline">Cliquer ici</b>
              </div>
            </div>
          </div>
          <div class="is-flex is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-border-top">
            <div class="is-size-5 is-uppercase">
              Gestions des tranches et batiments
            </div>
          </div>
          <div
            class="is-vcentered is-minH50p is-padding-left-small"
            :class="program.use_tranche ? 'has-background-light is-border-bottom is-border-top' : 'has-background-dark'">
            <div
              style="min-height: 100%"
              class="is-flex is-space-between">
              <div
                class="is-flex is-align-items-center is-padding-top-xsmall is-padding-bottom-xsmall">
                <div>
                  <input
                    id="use_tranche"
                    v-model="program.use_tranche"
                    name="use_tranche"
                    class="switch is-success is-rounded"
                    type="checkbox">
                  <label
                    for="use_tranche"
                    style="font-size: 12.5px"
                    :class="program.use_tranche ? '' : 'has-text-white'"
                    class="is-uppercase">Gérer le {{ nameToUse }} par tranche</label>
                </div>
              </div>
              <div
                class="btn_style">
                <a
                  class="btn-export is-uppercase is-nowrap"
                  @click="program.use_tranche ? addProgramTranche() : addProgramBuilding()"
                  :class="program.use_tranche ? 'has-text-white has-background-dark' : 'has-background-light is-border-top is-border-bottom'">
                  &nbsp;<span>{{ program.use_tranche ? 'Ajouter une tranche' : 'Ajouter un bâtiment' }}</span>
                </a>
              </div>
            </div>
          </div>
          <div
            v-if="program.use_tranche && program.tranches.length > 0"
            class="is-padding is-border-bottom">
            <div class="column is-12 title is-5 is-uppercase is-marginless-bottom is-marginless-top">
              <b>Tranches</b>
            </div>
            <div
              class="column is-12 columns is-multiline"
              v-for="(tranche, index_tranche) in program.tranches"
              :key="tranche.pk + '-tranche' + index_tranche">
              <!-- <div class="is-padding-left-xsmall">
                <r-label
                  label="Nom de la tranche"
                  :is-required="false"></r-label>
              </div> -->
              <!-- MODIFICATION GFA -->
              <div
                class="column is-12 columns is-multiline is-padding-left-xsmall"
                style="margin-bottom: 0; padding: 0">
                <r-label
                  class="column is-4"
                  style="margin-bottom: 0; padding-bottom: 0"
                  label="Nom de la tranche"
                  :is-required="false"></r-label>
                <r-label
                  class="column is-2"
                  style="margin-bottom: 0; padding-bottom: 0"
                  label="GFA tranche"
                  :is-required="false"></r-label>
              </div>
              <div class="block column is-4 is-marginless is-margin-bottom-xsmall">
                <div class="control">
                  <v-input
                    :has-addons="true"
                    :id="'trancheName' + index_tranche"
                    :name="'trancheName' + index_tranche"
                    @input="tranche.name = $event; tranche.building_updated = true"
                    :model="tranche.name"
                    data-vv-as="Nom de la tranche"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val">
                    <p
                      class="control"
                      slot="addonRight">
                      <a
                        @click.prevent.stop="removeProgramTranche(tranche, index_tranche)"
                        class="button is-square is-white is-border">
                        <i class="fal fa-trash-alt"></i>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <!-- MODIFICATION GFA -->
              <div class="column is-2">
                <div class="control columns is-gapless">
                  <div class="select is-fullwidth">
                    <v-input
                      id="remuneration"
                      :name="'remuneration'"
                      :classes-input="'is-active is-input is-fullwidth'"
                      :has-incrementations="true"
                      input-type="number"
                      :has-addons="true"
                      @input="tranche.gfa_defined_percentage = $event"
                      :model="tranche.gfa_defined_percentage"
                      :min="1"
                      :max="100"
                      :step="1"
                      :number="true"
                      v-validate="'decimal:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as=" ">
                      <p
                        class="control"
                        slot="addonRight">
                        <a class="button is-border is-square is-static">
                          <span class="icon"><i class="fas fa-percentage"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
              </div>
              <div class="is-padding-left-xsmall is-border-bottom is-padding-bottom-small">
                <div class="columns is-multiline">
                  <div class="column is-6">
                    <r-label
                      label="Prévisionnel début des travaux"
                      :is-required="false"></r-label>
                    <div class="control columns is-gapless">
                      <div class="select is-fullwidth">
                        <select
                          :value="tranche.debut_travaux ? tranche.debut_travaux.toString().substring(4, 5) : null"
                          @change="updateTrancheTrimester($event.target.value, index_tranche, 'debut_travaux')">
                          <option :value="'0'">
                            Trimestre
                          </option>
                          <option
                            v-for="(t, i) in quarters"
                            :value="i + 1"
                            :key="i">
                            {{ t[i + 1] }}
                          </option>
                        </select>
                      </div>
                      <div class="select is-fullwidth is-margin-left">
                        <select
                          :value="tranche.debut_travaux ? tranche.debut_travaux.toString().substring(0, 4) : null"
                          @change="updateTrancheYear($event.target.value, index_tranche, 'debut_travaux')">
                          <option :value="'0000'">
                            Année
                          </option>
                          <option
                            v-for="year in years"
                            :value="year"
                            :key="year">
                            {{ year }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6">
                    <r-label
                      label="Prévisionnel fin des travaux"
                      :is-required="false"></r-label>
                    <div class="control columns is-gapless">
                      <div class="select is-fullwidth">
                        <select
                          :value="tranche.fin_travaux ? tranche.fin_travaux.toString().substring(4, 5) : null"
                          @change="updateTrancheTrimester($event.target.value, index_tranche, 'fin_travaux')">
                          <option :value="'0'">
                            Trimestre
                          </option>
                          <option
                            v-for="(t, i) in quarters"
                            :value="i + 1"
                            :key="i">
                            {{ t[i + 1] }}
                          </option>
                        </select>
                      </div>
                      <div class="select is-fullwidth is-margin-left">
                        <select
                          :value="tranche.fin_travaux ? tranche.fin_travaux.toString().substring(0, 4) : null"
                          @change="updateTrancheYear($event.target.value, index_tranche, 'fin_travaux')">
                          <option :value="'0000'">
                            Année
                          </option>
                          <option
                            v-for="year in years"
                            :value="year"
                            :key="year">
                            {{ year }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6">
                    <r-label
                      label="Livraison"
                      :is-required="false"></r-label>
                    <div class="control columns is-gapless">
                      <div class="select is-fullwidth">
                        <select
                          :value="tranche.date_livraison ? tranche.date_livraison.toString().substring(4, 5) : null"
                          @change="updateTrancheTrimester($event.target.value, index_tranche, 'date_livraison')">
                          <option :value="'0'">
                            Trimestre
                          </option>
                          <option
                            v-for="(t, i) in quarters"
                            :value="i + 1"
                            :key="i">
                            {{ t[i + 1] }}
                          </option>
                        </select>
                      </div>
                      <div class="select is-fullwidth is-margin-left">
                        <select
                          :value="tranche.date_livraison ? tranche.date_livraison.toString().substring(0, 4) : null"
                          @change="updateTrancheYear($event.target.value, index_tranche, 'date_livraison')">
                          <option :value="'0000'">
                            Année
                          </option>
                          <option
                            v-for="year in years"
                            :value="year"
                            :key="year">
                            {{ year }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6">
                    <r-label
                      label="Actabilité"
                      :is-required="false"></r-label>
                    <div class="control columns is-gapless">
                      <div class="select is-fullwidth">
                        <select
                          :value="tranche.date_actabilite ? tranche.date_actabilite.toString().substring(4, 5) : null"
                          @change="updateTrancheTrimester($event.target.value, index_tranche, 'date_actabilite')">
                          <option :value="'0'">
                            Trimestre
                          </option>
                          <option
                            v-for="(t, i) in quarters"
                            :value="i + 1"
                            :key="i">
                            {{ t[i + 1] }}
                          </option>
                        </select>
                      </div>
                      <div class="select is-fullwidth is-margin-left">
                        <select
                          :value="tranche.date_actabilite ? tranche.date_actabilite.toString().substring(0, 4) : null"
                          @change="updateTrancheYear($event.target.value, index_tranche, 'date_actabilite')">
                          <option :value="'0000'">
                            Année
                          </option>
                          <option
                            v-for="year in years"
                            :value="year"
                            :key="year">
                            {{ year }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div
                    class="column is-12"
                    v-if="tranche.construction_data">
                    <r-label
                      label="Aménagements prévus (séparer par une virgule)"
                      :is-required="false"
                      :value="tranche.construction_data.planned_developments"></r-label>
                    <wysiwyg-editor
                      :key="tranche.pk"
                      :model="tranche.construction_data.planned_developments"
                      :light-program="true"
                      :light="true"
                      @change="tranche.construction_data.planned_developments = $event"
                      class="has-background-white" />
                  </div>
                </div>
              </div>
              <div
                class="column is-12 has-background-white--darken1">
                <div class="column is-12 title is-5 is-uppercase is-marginless-bottom is-marginless-top">
                  <div class="is-flex is-nowrap is-space-between">
                    <div class="is-flex is-align-items-center">
                      <b>Bâtiments</b>
                    </div>
                    <div
                      class="btn_style">
                      <a
                        class="btn-export is-uppercase is-nowrap"
                        @click="addProgramBuildingInTranche(index_tranche)"
                        :class="'has-background-light is-border-top is-border-bottom'">
                        &nbsp;<span>{{ 'Ajouter un bâtiment' }}</span>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="column is-12 columns is-multiline"
                  v-for="(building, i) in tranche.buildings"
                  :key="building.pk + '-batiment' + i">
                  <div class="is-padding-left-xsmall">
                    <r-label
                      label="Nom du bâtiment"
                      :is-required="false"></r-label>
                  </div>
                  <div class="block column is-4 is-marginless">
                    <div class="control">
                      <v-input
                        :has-addons="true"
                        :id="'buildingName' + i"
                        :name="'buildingName' + i"
                        @input="building.name = $event; building.building_updated = true"
                        :model="building.name"
                        data-vv-as="Nom du bâtiment"
                        v-validate="'min:2'"
                        :errors-bag="errors"
                        data-vv-value-path="val">
                        <p
                          class="control"
                          slot="addonRight">
                          <a
                            @click.prevent.stop="removeProgramBuildingInTranche(building, i, index_tranche)"
                            class="button is-square is-white is-border">
                            <i class="fal fa-trash-alt"></i>
                          </a>
                        </p>
                      </v-input>
                    </div>
                  </div>
                  <program-building-lots
                    :lots="programLots"
                    :building="building"></program-building-lots>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="program.buildings.length > 0 && !program.use_tranche"
            class="is-padding is-border-bottom">
            <div class="column is-12 title is-5 is-uppercase is-marginless-bottom is-marginless-top">
              <b>Bâtiments</b>
            </div>
            <div
              class="column is-12 columns is-multiline"
              v-for="(building, i) in program.buildings"
              :key="building.pk">
              <div class="is-padding-left-xsmall">
                <r-label
                  label="Nom du bâtiment"
                  :is-required="false"></r-label>
              </div>
              <div class="block column is-4 is-marginless">
                <div class="control">
                  <v-input
                    :has-addons="true"
                    :id="'buildingName' + i"
                    :name="'buildingName' + i"
                    @input="building.name = $event; building.building_updated = true"
                    :model="building.name"
                    data-vv-as="Nom du bâtiment"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val">
                    <p
                      class="control"
                      slot="addonRight">
                      <a
                        @click.prevent.stop="removeProgramBuilding(building, i)"
                        class="button is-square is-white is-border">
                        <i class="fal fa-trash-alt"></i>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <!-- <div class="column is-12 has-background-white--darken1 is-margin-left-xsmall"
                    v-if="b.lots && b.lots.length">
                  <div class="is-size-6 is-uppercase is-padding-bottom-xsmall">Lots concernés</div>
                  <span class="tag is-primary is-margin-right-xsmall is-wAuto"
                        v-for="lotBatiment in b.lots" :key="lotBatiment.pk">
                    <router-link
                            :to="{name: 'LotVue', params: {id: lotBatiment.pk}}"
                            class="has-text-white">
                      {{lotBatiment.ref}}
                    </router-link>
                  </span>
                </div> -->
              <program-building-lots
                :lots="programLots"
                :building="building"></program-building-lots>
            </div>
          </div>
          <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-border-bottom">
            <div class="is-size-5 is-uppercase">
              Données Promoteur
            </div>
          </div>
          <div class="is-padding">
            <div
              class="columns is-multiline"
              v-if="program.promoteur_data">
              <div class="column is-6">
                <r-label
                  label="Nom de la société"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.promoteur_data.company_name"></r-label>
                <div class="control">
                  <v-input
                    id="company_name"
                    name="company_name"
                    @input="updateValue($event, 'promoteur_data', 'company_name')"
                    :model="program.promoteur_data.company_name"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Nom de la société">
                  </v-input>
                </div>
              </div>
              <div class="column is-12">
                <wysiwyg-editor
                  :model="program.promoteur_data.reservant"
                  placeholder="XXXXX au capital de XXXXX €, dont le siège social est situé XXXXX — XXXXX XXXXX, immatriculé au RCS de XXXXX sous le n° XXXXX dûment représentée aux présentes par la XXXXX au capital de XXXXX dont le siège social est XXXXX — XXXXX XXXXX, immatriculé au RCS de XXXXX sous le n° XXXXX, elle même representé par son gérant XXXXX."
                  :light-program="true"
                  :light="true"
                  @change="updateValue($event, 'promoteur_data', 'reservant')"
                  class="has-background-white" />
              </div>
              <div class="column is-6">
                <r-label
                  label="Nom du gérant/représentant de la société"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.promoteur_data.rep_last_name"></r-label>
                <div class="control">
                  <v-input
                    id="rep_last_name"
                    name="rep_last_name"
                    @input="updateValue($event, 'promoteur_data', 'rep_last_name')"
                    :model="program.promoteur_data.rep_last_name"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Nom du gérant/représentant de la société">
                  </v-input>
                </div>
              </div>
              <div class="column is-6">
                <r-label
                  label="Prénom du gérant/représentant de la société"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.promoteur_data.rep_first_name"></r-label>
                <div class="control">
                  <v-input
                    id="rep_first_name"
                    name="rep_first_name"
                    @input="updateValue($event, 'promoteur_data', 'rep_first_name')"
                    :model="program.promoteur_data.rep_first_name"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Prénom du gérant/représentant de la société">
                  </v-input>
                </div>
              </div>
              <div class="column is-6">
                <phone-input
                  v-if="!loadingAccount"
                  :value="program.promoteur_data.rep_phone"
                  :placeholder="'Numéro de téléphone'"
                  :required="hasCheck"
                  @input="updateValue($event, 'promoteur_data', 'rep_phone')">
                  <r-label
                    slot="label"
                    label="Téléphone de correspondance"
                    :is-required="hasCheck"
                    :red-check="hasCheck"
                    :value="program.promoteur_data.rep_phone"
                    :truncate="false">
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                      <i class="fal fa-info-circle"></i>
                    </span>
                  </r-label>
                </phone-input>
              </div>
              <div class="column is-6">
                <r-label
                  :label="'Email de correspondance'"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.promoteur_data.rep_email"></r-label>
                <div class="control">
                  <v-input
                    :has-addons="true"
                    id="program.promoteur_data.rep_email"
                    name="program.promoteur_data.rep_email"
                    @input="updateValue($event, 'promoteur_data', 'rep_email')"
                    :model="program.promoteur_data.rep_email"
                    v-validate="'email'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Email">
                    <p
                      class="control"
                      slot="addonLeft">
                      <a class="button is-static is-square is-static">
                        <span class="icon"><i class="fas fa-paper-plane"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <div class="column is-12">
                <address-input
                  label="Adresse de correspondance"
                  :source="program.promoteur_data.rep_address"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  @update="updateAddress($event, 'promoteur_data.rep_address')">
                </address-input>
              </div>
            </div>
          </div>
          <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border-bottom">
            <div class="is-size-5 is-uppercase">
              Notaire de l'opération
            </div>
          </div>
          <div class="is-padding">
            <div
              class="columns is-multiline"
              v-if="program.notary_data">
              <div class="column is-6">
                <r-label
                  :label="program.notary_data.tiers_id ? 'Notaire du référentiel' : 'Rechercher un notaire au référentiel'"
                  :is-required="false"
                  :value="program.notary_data.tiers_id" />
                <tiers-selector
                  :selected="selectedNotaire"
                  :slot-ref="program.notary_data"
                  :types="['notaire']"
                  placeholder="Nom, ville..."
                  @select="selectNotaire"
                  @unlink="unlinkNotaire" />
              </div>
              <div class="column is-6"></div>
              <div class="column is-6">
                <r-label
                  label="Nom du notaire"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.notary_data.name"></r-label>
                <div class="control">
                  <v-input
                    id="program.notary_data.name"
                    :disabled="!!program.notary_data.tiers_id"
                    name="program.notary_data.name"
                    @input="updateValue($event, 'notary_data', 'name')"
                    :model="program.notary_data.name"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Nom du notaire">
                  </v-input>
                </div>
              </div>
              <div class="column is-6">
                <r-label
                  label="Téléphone du notaire"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  :value="program.notary_data.phone"
                  :truncate="false">
                  <span
                    class="is-padding-left-xsmall"
                    v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                    <i class="fal fa-info-circle"></i>
                  </span>
                </r-label>
                <div class="control">
                  <v-input
                    id="program.notary_data.phone"
                    :disabled="!!program.notary_data.tiers_id"
                    name="program.notary_data.phone"
                    @input="updateValue($event, 'notary_data', 'phone')"
                    :model="program.notary_data.phone"
                    v-validate="'min:10'"
                    :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Téléphone"
                    :has-addons="true">
                    <p
                      class="control"
                      slot="addonLeft">
                      <a class="button is-static is-square is-static">
                        <span class="icon"><i class="fas fa-phone-office"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <div class="column is-6">
                <r-label
                  label="Email"
                  :value="program.notary_data.email"
                  :is-required="false"></r-label>
                <div class="control">
                  <v-input
                    :has-addons="true"
                    id="program.notary_data.email"
                    :disabled="!!program.notary_data.tiers_id"
                    name="program.notary_data.email"
                    @input="updateValue($event, 'notary_data', 'email')"
                    :model="program.notary_data.email"
                    v-validate="'email'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Email">
                    <p
                      class="control"
                      slot="addonLeft">
                      <a class="button is-static is-square is-static">
                        <span class="icon"><i class="fas fa-paper-plane"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <div class="column is-12">
                <address-input
                  v-if="!program.notary_data.tiers_id"
                  label="Adresse de correspondance"
                  :source="program.notary_data.address"
                  :is-required="hasCheck"
                  :red-check="hasCheck"
                  @update="updateAddress($event, 'notary_data.address')">
                </address-input>
                <div
                  v-else
                  class="columns is-multiline">
                  <div class="column is-6">
                    <r-label
                      label="Adresse de correspondance"
                      :is-required="false"
                      :value="tiersAddressResume(program.notary_data.address)" />
                    <input
                      :value="tiersAddressResume(program.notary_data.address)"
                      type="text"
                      class="input"
                      disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isAmenagement">
            <!-- Géomètre -->
            <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border-bottom">
              <div class="is-size-5 is-uppercase">
                Géomètre
              </div>
            </div>
            <div class="is-padding">
              <div
                class="columns is-multiline"
                v-if="program.geometrician_data">
                <div class="column is-6">
                  <r-label
                    :label="program.geometrician_data.tiers_id ? 'Géomètre du référentiel' : 'Rechercher un géomètre au référentiel'"
                    :is-required="false"
                    :value="program.geometrician_data.tiers_id" />
                  <tiers-selector
                    :selected="selectedGeometre"
                    :slot-ref="program.geometrician_data"
                    :types="['geometre']"
                    placeholder="Nom, ville..."
                    @select="selectGeometre"
                    @unlink="unlinkGeometre" />
                </div>
                <div class="column is-6"></div>
                <div class="column is-6">
                  <r-label
                    label="Nom du géomètre"
                    :is-required="hasCheck"
                    :red-check="hasCheck"
                    :value="program.geometrician_data.name"></r-label>
                  <div class="control">
                    <v-input
                      id="program.geometrician_data.name"
                      :disabled="!!program.geometrician_data.tiers_id"
                      name="program.geometrician_data.name"
                      @input="updateValue($event, 'geometrician_data', 'name')"
                      :model="program.geometrician_data.name"
                      v-validate="'min:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="Nom du géomètre">
                    </v-input>
                  </div>
                </div>
                <div class="column is-6">
                  <r-label
                    label="Téléphone du géomètre"
                    :is-required="hasCheck"
                    :red-check="hasCheck"
                    :value="program.geometrician_data.phone"
                    :truncate="false">
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                      <i class="fal fa-info-circle"></i>
                    </span>
                  </r-label>
                  <div class="control">
                    <v-input
                      id="program.geometrician_data.phone"
                      :disabled="!!program.geometrician_data.tiers_id"
                      name="program.geometrician_data.phone"
                      @input="updateValue($event, 'geometrician_data', 'phone')"
                      :model="program.geometrician_data.phone"
                      v-validate="'min:10'"
                      :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Téléphone"
                      :has-addons="true">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-static is-square is-static">
                          <span class="icon"><i class="fas fa-phone-office"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <div class="column is-6">
                  <r-label
                    label="Email"
                    :value="program.geometrician_data.email"
                    :is-required="hasCheck"
                    :red-check="hasCheck"></r-label>
                  <div class="control">
                    <v-input
                      :has-addons="true"
                      id="program.geometrician_data.email"
                      :disabled="!!program.geometrician_data.tiers_id"
                      name="program.geometrician_data.email"
                      @input="updateValue($event, 'geometrician_data', 'email')"
                      :model="program.geometrician_data.email"
                      v-validate="'email'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Email">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-static is-square is-static">
                          <span class="icon"><i class="fas fa-paper-plane"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <div class="column is-6">
                  <r-label
                    label="Prix"
                    :is-required="hasCheck"
                    :red-check="hasCheck"
                    :value="program.geometrician_data.price"
                    :truncate="false">
                  </r-label>
                  <div class="control">
                    <v-input
                      :has-addons="true"
                      id="program.geometrician_data.price"
                      name="program.geometrician_data.price"
                      @click="selectedInput = 'ttc'"
                      @input="updateValue($event, 'geometrician_data', 'price')"
                      :model="program.geometrician_data.price"
                      input-type="number"
                      v-validate="'decimal:2'"
                      :three-space="true"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      :number="true"
                      data-vv-as="Prix">
                      <p
                        class="control"
                        slot="addonRight">
                        <a class="button is-static is-border">
                          <span class="icon"><i class="fas fa-euro-sign"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
              </div>
            </div>
            <!-- Architecte coordinateur -->
            <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border-bottom">
              <div class="is-size-5 is-uppercase">
                Architecte coordinateur
              </div>
            </div>
            <div class="is-padding">
              <div
                class="columns is-multiline"
                v-if="program.architect_data">
                <div class="column is-6">
                  <r-label
                    :label="program.architect_data.tiers_id ? 'Architecte du référentiel' : 'Rechercher un architecte au référentiel'"
                    :is-required="false"
                    :value="program.architect_data.tiers_id" />
                  <tiers-selector
                    :selected="selectedArchitecte"
                    :slot-ref="program.architect_data"
                    :types="['architecte']"
                    placeholder="Nom, ville..."
                    @select="selectArchitecte"
                    @unlink="unlinkArchitecte" />
                </div>
                <div class="column is-6"></div>
                <div class="column is-6">
                  <r-label
                    label="Nom de l'architecte"
                    :is-required="hasCheck"
                    :red-check="hasCheck"
                    :value="program.architect_data.name"></r-label>
                  <div class="control">
                    <v-input
                      id="program.architect_data.name"
                      :disabled="!!program.architect_data.tiers_id"
                      name="program.architect_data.name"
                      @input="updateValue($event, 'architect_data', 'name')"
                      :model="program.architect_data.name"
                      v-validate="'min:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="Nom de l'architecte">
                    </v-input>
                  </div>
                </div>
                <div class="column is-6">
                  <r-label
                    label="Téléphone de l'architecte"
                    :is-required="hasCheck"
                    :red-check="hasCheck"
                    :value="program.architect_data.phone"
                    :truncate="false">
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                      <i class="fal fa-info-circle"></i>
                    </span>
                  </r-label>
                  <div class="control">
                    <v-input
                      id="program.architect_data.phone"
                      :disabled="!!program.architect_data.tiers_id"
                      name="program.architect_data.phone"
                      @input="updateValue($event, 'architect_data', 'phone')"
                      :model="program.architect_data.phone"
                      v-validate="'min:10'"
                      :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Téléphone"
                      :has-addons="true">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-static is-square is-static">
                          <span class="icon"><i class="fas fa-phone-office"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <div class="column is-6">
                  <r-label
                    label="Email"
                    :value="program.architect_data.email"
                    :is-required="hasCheck"
                    :red-check="hasCheck"></r-label>
                  <div class="control">
                    <v-input
                      :has-addons="true"
                      id="program.architect_data.email"
                      :disabled="!!program.architect_data.tiers_id"
                      name="program.architect_data.email"
                      @input="updateValue($event, 'architect_data', 'email')"
                      :model="program.architect_data.email"
                      v-validate="'email'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Email">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-static is-square is-static">
                          <span class="icon"><i class="fas fa-paper-plane"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <div class="column is-6">
                  <r-label
                    label="Prix"
                    :is-required="hasCheck"
                    :red-check="hasCheck"
                    :value="program.architect_data.price"
                    :truncate="false">
                  </r-label>
                  <div class="control">
                    <v-input
                      :has-addons="true"
                      id="program.architect_data.price"
                      name="program.architect_data.price"
                      @click="selectedInput = 'ttc'"
                      @input="updateValue($event, 'architect_data', 'price')"
                      :model="program.architect_data.price"
                      input-type="number"
                      v-validate="'decimal:2'"
                      :three-space="true"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      :number="true"
                      data-vv-as="Prix">
                      <p
                        class="control"
                        slot="addonRight">
                        <a class="button is-static is-border">
                          <span class="icon"><i class="fas fa-euro-sign"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- REFERENTS PRESCRIBERS -->
          <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-border-bottom">
            <div class="is-size-5 is-uppercase">
              <span v-helper.right="'2OFlSEEjutEZvB8mSqvvt0'">référents programme&nbsp;&nbsp;<i class="fal fa-info-circle" /></span>
            </div>
          </div>
          <div class="is-padding-right is-padding-left is-padding-bottom-xlarge">
            <div
              v-for="(referent, i) in program.referents"
              :key="'referent'+i"
              class="columns is-multiline is-padding-top">
              <div class="column is-11">
                <span class="is-uppercase">référent à contacter {{ i + 1 }}</span>
                <span class="notification is-warning is-radiusless is-size-7 is-padding-xsmall is-border is-border--warning is-margin-left-xsmall">
                  Veuillez renseigner au minimum une information de contact (mail ou téléphone)
                </span>
              </div>
              <div class="column is-1">
                <a
                  class="button is-square is-grey is-inverted is-border is-pulled-right"
                  @click.prevent.stop="program.referents.splice(i, 1)">
                  <i class="fal fa-trash-alt" />
                </a>
              </div>
              <div class="column is-3">
                <!-- LASTNAME -->
                <r-label
                  :is-required="false"
                  label="Nom" />
                <div class="control">
                  <v-input
                    v-validate="''"
                    :model="referent.last_name"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Nom"
                    @input="referent.last_name= $event" />
                </div>
              </div>
              <div class="column is-3">
                <!-- FIRSTNAME -->
                <r-label
                  :is-required="false"
                  label="Prénom" />
                <div class="control">
                  <v-input
                    v-validate="''"
                    :model="referent.first_name"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Prénom"
                    @input="referent.first_name = $event" />
                </div>
              </div>
              <div class="column is-4">
                <!-- PROFESSION -->
                <r-label
                  :is-required="false"
                  label="profession" />
                <div class="control">
                  <v-input
                    v-validate="''"
                    :model="referent.profession"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="profession"
                    @input="referent.profession = $event" />
                </div>
              </div>
              <div class="column is-3">
                <!-- EMAIL -->
                <r-label
                  :is-required="false"
                  label="Mail" />
                <div class="control">
                  <v-input
                    :id="'referent.email'+i"
                    v-validate="'email'"
                    :name="'referent.email'+i"
                    :model="referent.email"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Email"
                    @input="referent.email = $event" />
                </div>
              </div>
              <div class="column is-3">
                <!-- PHONE -->
                <r-label
                  :is-required="false"
                  label="Téléphone" />
                <div class="control">
                  <v-input
                    :name="'referent.phone'+i"
                    :id="'referent.phone'+i"
                    @input="referent.phone = $event"
                    :model="referent.phone"
                    :errors-bag="errors"
                    :input-type="'tel'"
                    :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                    v-validate="'min:10'"
                    data-vv-value-path="val"
                    data-vv-as="Téléphone"
                    :has-addons="true">
                    <p
                      class="control"
                      slot="addonLeft">
                      <a class="button is-square is-static is-border">
                        <span class="icon"><i class="fas fa-phone-office"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <!-- PICTURE -->
              <div class="column is-12 field">
                <r-label
                  :label="'Photo'"
                  :is-required="false" />
                <upload-file
                  :custom-id="'referentPicture'+i"
                  :source-documents="referent.picture"
                  :unique="true"
                  :is-square-input="false"
                  @upload="uploadFile({ file: $event, referentIndex: i })"
                  @deleteDocument="(file, index) => deleteFile(i, 'referents')" />
              </div>
            </div>
            <div
              v-if="program.referents.length < 5"
              class="is-padding-top has-text-right">
              <a
                class="button is-rounded is-transform-none is-padding-right-large is-padding-left-large"
                @click="program.referents.push({ last_name: null, first_name: null, email: null, phone: null, profession: null, picture: [] })">
                &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square" /></span><span>Ajouter un référent</span></a>
            </div>
          </div>
        </div>
        <div
          class="has-background-white is-border"
          v-show="panel === 'FICHE_PROGRAMME'">
          <div>
            <tabs
              mode="emitter"
              :links="programFicheTabs"
              :is-fullwidth="true"
              :level="1"
              :current-tab="programFicheTab"
              @changeView="programFicheTab = $event"></tabs>
          </div>
          <div v-show="programFicheTab === 'FICHE_DESCRIPTIVE'">
            <div class="is-padding has-background-light">
              <div class="columns">
                <div class="column is-4 columns is-column is-gapless is-space-between is-marginless">
                  <div class="control">
                    <input
                      id="is_optionable"
                      type="checkbox"
                      name="is_optionable"
                      v-model="program.is_optionable"
                      class="switch is-success is-rounded is-medium">
                    <label
                      for="is_optionable"
                      class="is-uppercase">
                      <span
                        v-if="program.is_optionable"
                        class="is-size-6 is-margin-top-xxsmall">{{ nameToUse }} optionnable</span>
                      <span
                        v-else
                        class="is-size-6 is-margin-top-xxsmall">{{ nameToUse }} non optionnable</span>
                      &nbsp;
                    </label>
                  </div>
                </div>
                <div
                  class="column is-4 columns is-column is-gapless is-space-between is-marginless">
                  <div class="control">
                    <input
                      id="pre_reserved_auto"
                      type="checkbox"
                      name="pre_reserved_auto"
                      v-model="program.pre_reserved_auto"
                      class="switch is-success is-rounded is-medium">
                    <label
                      for="pre_reserved_auto"
                      class="is-uppercase">
                      <span
                        v-if="program.pre_reserved_auto"
                        class="is-size-6 is-margin-top-xxsmall">VALIDATION PRÉ-RÉSERVATION AUTOMATIQUE</span>
                      <span
                        v-else
                        class="is-size-6 is-margin-top-xxsmall">VALIDATION PRÉ-RÉSERVATION AUTOMATIQUE</span>
                      &nbsp;
                      <span
                        class="is-margin-left-xsmall icon is-medium"
                        v-helper.bottom.small="'5O0hm4YMtmZw40azY3DPoj'">
                        <i class="fal fa-question-circle has-text-grey"></i>
                      </span>
                    </label>
                  </div>
                </div>
                <div
                  v-if="canUseElectronicSign"
                  class="column is-4 columns is-column is-gapless is-space-between is-marginless">
                  <div class="control">
                    <input
                      id="always_digital"
                      type="checkbox"
                      name="always_digital"
                      v-model="program.always_digital"
                      class="switch is-success is-rounded is-medium">
                    <label
                      for="always_digital"
                      class="is-uppercase">
                      <span
                        v-if="program.always_digital"
                        class="is-size-6 is-margin-top-xxsmall">AUTORISATION SIGNATURE ÉLECTRONIQUE</span>
                      <span
                        v-else
                        class="is-size-6 is-margin-top-xxsmall">AUTORISATION SIGNATURE ÉLECTRONIQUE</span>
                      &nbsp;
                      <span
                        class="is-margin-left-xsmall icon is-medium"
                        v-helper.bottom.small="'2KvsNxu1gl5GvNt7f6AMTs'">
                        <i class="fal fa-question-circle has-text-grey"></i>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="is-padding has-background-white--darken1">
              <div class="columns">
                <div class="column is-12 is-paddingless">
                  <r-label
                    label="Taux de commercialisation"
                    :value="program.remuneration"
                    :is-required="hasCheck"
                    :red-check="hasCheck"></r-label>
                  <div class="columns is-gapless">
                    <div class="column is-2">
                      <div class="control">
                        <v-input
                          :has-addons="true"
                          id="program.remuneration"
                          name="program.remuneration"
                          @input="$event == '' ? updateValue(null, 'remuneration') : updateValue($event, 'remuneration')"
                          :model="program.remuneration"
                          v-validate="'min:1'"
                          :step=".01"
                          :max="100"
                          :number="true"
                          input-type="number"
                          :errors-bag="errors"
                          data-vv-value-path="val"
                          data-vv-as="Rémuneration">
                          <p
                            class="control"
                            slot="addonRight">
                            <a class="button is-static is-square is-border">
                              <span class="icon"><i class="fas fa-percentage"></i></span>
                            </a>
                          </p>
                        </v-input>
                      </div>
                    </div>
                    <div class="column">
                      <div class="notification is-warning is-radiusless is-size-6 is-padding-xsmall is-border is-border--warning">
                        Le taux de commercialisation n'est visible que par les administrateurs, les managers et les
                        vendeurs internes
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="is-padding has-background-white--darken1">
              <div class="columns">
                <div class="column is-4">
                  <div class="control">
                    <r-label
                      class="is-margin-bottom-small"
                      label="Durée de validité des options (h)"
                      :is-required="true"
                      :red-check="hasCheck"
                      :value="program.option_period"></r-label>
                    <v-input
                      :has-addons="true"
                      id="program.option_period"
                      name="program.option_period"
                      @input="updateValue($event, 'option_period')"
                      :model="program.option_period"
                      v-validate="'required'"
                      :step="1"
                      :min="1"
                      :max="9999"
                      input-type="number"
                      :number="true"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Durée des Options (h)">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-static is-square is-border">
                          <span class="icon"><i class="fal fa-clock"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <div class="column is-4">
                  <div class="control">
                    <r-label
                      class="is-margin-bottom-small"
                      label="Nombre d'option simultanée par utilisateur"
                      :is-required="true"
                      :red-check="hasCheck"
                      :value="program.max_options_by_program"></r-label>
                    <v-input
                      :has-addons="true"
                      id="program.max_options_by_program"
                      name="program.max_options_by_program"
                      @input="val => val > 0 ? updateValue(val, 'max_options_by_program') : updateValue(1, 'max_options_by_program')"
                      :model="program.max_options_by_program"
                      v-validate="'required'"
                      :step="1"
                      :min="1"
                      :max="120"
                      input-type="number"
                      :number="true"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Nombre d'option simultanée">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-static is-square is-border">
                          <span class="icon"><i class="fal fa-clock"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border-bottom">
              <div class="is-size-5 is-uppercase">
                Description du {{ nameToUse }}
              </div>
            </div>
            <div class="is-padding">
              <div class="columns is-multiline has-cloud-checkradiocase">
                <div class="column is-12">
                  <div class="columns is-gapless has-background-warning">
                    <div class="is-size-7 is-padding-xsmall">
                      <span class="is-uppercase">
                        Les dispositifs grisés sont présents sur des lots, veuillez les retirer des lots afin de pouvoir les retirer du {{ nameToUse }}
                      </span>
                    </div>
                  </div>
                  <r-label
                    label="Dispositifs Fiscaux"
                    :is-required="false"></r-label>
                  <div class="columns is-gapless is-multiline">
                    <div
                      class="column is-4"
                      v-for="t in dispositifs"
                      :key="t.value">
                      <input
                        :disabled="unavailableDispositifs.includes(t.value)"
                        v-model="program.tax_dispositifs"
                        :value="t.value"
                        :name="t.value"
                        :id="t.value"
                        type="checkbox"
                        class="vadCheckradiocase is-fullwidth">
                      <label :for="t.value">{{ t.label }}</label>
                    </div>
                  </div>
                </div>
                <div class="column is-12">
                  <r-label
                    label="Certifications"
                    :is-required="false"></r-label>
                  <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                    <div
                      class="column is-4"
                      v-for="t in programCertificationsList"
                      :key="t.value">
                      <input
                        v-model="program.certifications"
                        :value="t.value"
                        :name="t.value"
                        :id="t.value"
                        type="checkbox"
                        class="vadCheckradiocase is-fullwidth">
                      <label :for="t.value">{{ t.label }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="has-background-light">
              <div class="title is-5 is-uppercase is-padding-top is-padding-right is-padding-left is-marginless">
                <b>Description</b>
              </div>
              <div
                class="is-border-bottom has-background-light is-padding"
                v-for="(d, i) in program.descriptions"
                :key="i">
                <div class="columns">
                  <div class="column">
                    <r-label
                      label="Titre de la description"
                      :value="d.title"
                      :is-required="true"
                      :red-check="hasCheck"></r-label>
                  </div>
                  <div class="column is-narrow has-text-right">
                    <a
                      @click.prevent.stop="program.descriptions.splice(i, 1)"
                      class="button is-square is-border is-radiusless is-margin-neg-top">
                      <i class="fal fa-trash-alt"></i>
                    </a>
                  </div>
                </div>
                <div class="block">
                  <div class="control">
                    <v-input
                      :id="'descTitle' + i"
                      :name="'descTitle' + i"
                      @input="d.title = $event"
                      :model="d.title"
                      data-vv-as="Titre de la description"
                      placeholder="Saisissez un titre"
                      v-validate="'required|min:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val">
                    </v-input>
                  </div>
                </div>
                <div class="block">
                  <r-label
                    label="Texte de la description"
                    :value="d.text"
                    :is-required="true"
                    :red-check="hasCheck"></r-label>
                  <div
                    class="field"
                    @mouseover="displayToolbar = true"
                    @mouseleave="displayToolbar = false">
                    <div class="control has-background-white">
                      <wysiwyg-editor
                        :model="d.text"
                        :id="'descText' + i"
                        :name="'descText' + i"
                        @change="d.text = $event" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="is-padding has-text-right">
                <a
                  @click="program.descriptions.push({ title: null, text: null })"
                  class="button is-rounded is-transform-none is-padding-right-large is-padding-left-large">
                  &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span><span>Ajouter une description</span>
                </a>
              </div>
            </div>
            <div class="is-padding has-background-white is-border-bottom">
              <div class="title is-5 is-uppercase is-margin-bottom-xsmall">
                <b>Photo, image, illustration</b>
                <span
                  class="is-padding-left-xsmall"
                  v-helper.bottom="'2DiSGTdOi0OL69yQrlGy7g'">
                  <i class="fal fa-info-circle"></i>
                </span>
              </div>
              <div>
                <r-label
                  label="Télécharger des images"
                  :is-required="false"></r-label>
                <upload-file
                  :custom-id="'program'"
                  :multiple="true"
                  :drag-enabled="true"
                  :draggable="true"
                  @uploadOrder="uploadOrderPictures($event)"
                  @upload="uploadDocument({ files: $event, target: 'pictures', isNew: true })"
                  @deleteDocument="deleteDocument({ document: $event, target: 'pictures' })"
                  :source-documents="program.pictures"></upload-file>
              </div>
              <div class="column is-12"></div>
            </div>
            <div class="is-padding">
              <div class="title is-5 is-uppercase is-margin-bottom-xsmall">
                <b>Vidéo</b>
              </div>
              <div
                class="columns"
                v-for="(v, i) in program.videos"
                :key="i">
                <div class="column is-paddingless-left is-paddingless-top is-paddingless-bottom is-5">
                  <div class="field">
                    <div class="is-flex is-margin-bottom-xxsmall">
                      <div class="is-self-centered">
                        <r-label
                          class="is-inline-flex"
                          :is-required="false"
                          :label="'Ajouter une vidéo'"></r-label>
                      </div>
                      <span
                        class="is-size-3 is-margin-left-xsmall"
                        v-helper.right="'8JUW6Ctd3m74CrIBctSLg'">
                        <i class="fas fa-question-circle fa-xs has-text-grey"></i>
                      </span>
                    </div>
                    <div class="control">
                      <div class="select is-fullwidth">
                        <select v-model="v.provider">
                          <option :value="null">
                            Sélectionner un fournisseur
                          </option>
                          <option
                            v-for="provider in videoProvidersList"
                            :value="provider.value"
                            :key="provider.label">
                            {{ provider.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-paddingless is-7">
                  <div class="field">
                    <div class="is-flex is-margin-bottom-xxsmall">
                      <div class="is-self-centered">
                        <r-label
                          class="is-inline-flex"
                          :is-required="false"
                          :label="'ID de la vidéo'"></r-label>
                      </div>
                      <span
                        class="is-size-3 is-margin-left-xsmall"
                        v-helper.right="'47Jh5uQklfTuUlVeQUSlkD'">
                        <i class="fas fa-question-circle fa-xs has-text-grey"></i>
                      </span>
                    </div>
                    <div class="control">
                      <v-input
                        :has-addons="true"
                        :id="'videoId' + i"
                        :name="'videoId' + i"
                        @input="v.video_id = $event"
                        :model="v.video_id"
                        data-vv-as="ID de la vidéo"
                        v-validate="'min:2'"
                        :errors-bag="errors"
                        data-vv-value-path="val">
                        <p
                          class="control"
                          slot="addonRight">
                          <a
                            @click.prevent.stop="program.videos.splice(i, 1)"
                            class="button is-square is-grey is-inverted is-border">
                            <i class="fal fa-trash-alt"></i>
                          </a>
                        </p>
                      </v-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="is-padding has-text-right">
                <a
                  @click="program.videos.push({ provider: null, video_id: null })"
                  class="button is-rounded is-transform-none is-padding-right-large is-padding-left-large">
                  &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span><span>Ajouter une vidéo</span></a>
              </div>
            </div>
          </div>
          <div
            v-show="programFicheTab === 'PARAMETRE'"
            class="is-border-top">
            <div class="is-padding has-background-light">
              <div class="columns is-multiline">
                <!-- <div
                  class="column columns is-column is-gapless is-space-between is-marginless is-padding-top-xsmall is-padding-bottom-xsmall"
                  :class="brikxEnabled ? 'is-6' : 'is-4'">
                  <div class="control">
                    <input
                      id="show_gfa"
                      type="checkbox"
                      name="show_gfa"
                      v-model="program.program_params.show_gfa"
                      class="switch is-success is-rounded is-medium">
                    <label
                      for="show_gfa"
                      class="is-uppercase">
                      <span
                        v-if="program.program_params.show_gfa"
                        class="is-size-6 is-margin-top-xxsmall">Taux GFA affiché</span>
                      <span
                        v-else
                        class="is-size-6 is-margin-top-xxsmall">Taux GFA masqué</span>
                      &nbsp;
                      <span
                        class="is-margin-left-xsmall icon is-medium"
                        v-helper.bottom.small="'6G7yUdJ6esxp0TpYOPc2Dr'">
                        <i class="fal fa-question-circle has-text-grey"></i>
                      </span>
                    </label>
                  </div>
                </div> -->
                <div
                  v-if="brikxEnabled"
                  class="column columns is-column is-gapless is-space-between is-marginless is-padding-top-xsmall is-padding-bottom-xsmall"
                  :class="brikxEnabled ? 'is-6' : 'is-4'">
                  <div class="control">
                    <input
                      id="display_on_brikx"
                      type="checkbox"
                      name="display_on_brikx"
                      v-model="program.display_on_brikx"
                      class="switch is-success is-rounded is-medium">
                    <label
                      for="display_on_brikx"
                      class="is-uppercase">
                      <span
                        class="is-size-6 is-margin-top-xxsmall">Diffuser sur Brikx</span>
                    </label>
                  </div>
                </div>
                <div
                  class="column columns is-column is-gapless is-space-between is-marginless is-padding-top-xsmall is-padding-bottom-xsmall"
                  :class="brikxEnabled ? 'is-6' : 'is-4'">
                  <div class="control">
                    <input
                      id="intern_visibility"
                      name="intern_visibility"
                      type="checkbox"
                      class="switch is-success is-rounded is-medium"
                      v-model="program.intern_visibility">
                    <label
                      for="intern_visibility"
                      class="is-uppercase">
                      <span
                        v-if="internVisible"
                        class="is-size-6 is-margin-top-xxsmall">Lots visibles vendeur(s) interne
                      </span>
                      <span
                        v-else
                        class="is-size-6 is-margin-top-xxsmall">Lots masqués vendeur(s) interne
                      </span>
                    </label>
                  </div>
                </div>
                <div
                  class="column columns is-column is-gapless is-space-between is-marginless is-padding-top-xsmall is-padding-bottom-xsmall"
                  :class="brikxEnabled ? 'is-6' : 'is-4'">
                  <div class="control">
                    <input
                      id="extern_visibility"
                      name="extern_visibility"
                      type="checkbox"
                      class="switch is-success is-rounded is-medium"
                      v-model="program.extern_visibility">
                    <label
                      for="extern_visibility"
                      class="is-uppercase">
                      <span
                        v-if="externVisible"
                        class="is-size-6 is-margin-top-xxsmall">Lots visibles prescripteur(s)
                      </span>
                      <span
                        v-else
                        class="is-size-6 is-margin-top-xxsmall">Lots masqués prescripteur(s)
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="is-padding">
              <div
                class="block"
                v-if="isAdmin">
                <r-label
                  :label="'État du ' + nameToUse"
                  :is-required="false"></r-label>
                <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                  <div
                    class="column is-3"
                    v-for="s in workflowStatusList"
                    :key="'status-'+s.value">
                    <input
                      v-model="program.status"
                      :value="s.value"
                      :name="'program.status'"
                      :id="'status-'+s.value"
                      type="radio"
                      class="vadCheckradiocase is-fullwidth">
                    <label :for="'status-'+s.value">{{ s.label }}</label>
                  </div>
                </div>
                <div
                  class="notification is-warning is-padding-top-small is-padding-bottom-small is-size-6"
                  v-if="program.status && statusHelperText"
                  v-html="statusHelperText">
                </div>
              </div>
              <div class="block">
                <r-label
                  label="État d'avancement"
                  :is-required="false"></r-label>
                <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                  <template v-for="step in programStepProgressList">
                    <div
                      class="column is-3"
                      :key="'step-'+step.value"
                      v-if="step.needType.map(type => type.toLowerCase()).includes(nameToUse.toLowerCase())">
                      <input
                        v-model="program.progress_step"
                        @click="cancelChoice(step.value)"
                        :value="step.value"
                        name="progress_step"
                        :id="'step-' + step.value"
                        type="radio"
                        class="vadCheckradiocase is-fullwidth">
                      <label
                        :for="'step-'+step.value"
                        :class="{'has-background-info' : program.progress_step === step.value}">{{ step.label
                        }}</label>
                    </div>
                  </template>
                </div>
              </div>
              <div class="columns">
                <div class="column is-5">
                  <div class="control">
                    <tag-input
                      @tagChange="updateValue($event, 'tags')"
                      :tags="program.tags"
                      v-model="program.tags"
                      :max-tags="4"
                      :max="30"
                      placeholder="Appuyez sur Entrée pour valider">
                    </tag-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="panel === 'DOCS'">
          <div class="has-background-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-border-bottom">
            <div class="is-size-4 is-uppercase title">
              Documents Divers
            </div>
          </div>
          <tabs
            :links="documentsTabs"
            :level="1"
            :current-tab="documentsTab"
            classes="has-background-light"
            mode="emitter"
            @changeView="documentsTab = $event"
            :is-fullwidth="true"></tabs>
          <div class="is-padding-bottom">
            <upload-file
              :multiple="true"
              :custom-id="'divers'"
              @uploadOrder="uploadOrder($event)"
              @upload="uploadDocument({ files: $event, isNew: true })"
              @deleteDocument="deleteDocument({ document: $event })"
              :hide-upload="documentsTab !== 'DOCUMENTS'"
              :drag-enabled="true"
              :has-destination="true"
              :draggable="documentsTab === 'DOCUMENTS' ? true : false"
              :destinations-list="programDestinations"
              :source-documents="documentsToDisplay"></upload-file>
          </div>
        </div>
        <div
          class="has-background-white is-border"
          v-show="panel === 'APPEL_DE_FOND'">
          <tabs
            v-if="appelDeFondsTabs.length"
            mode="emitter"
            :links="appelDeFondsTabs"
            :is-fullwidth="true"
            :level="1"
            :current-tab="appelDeFondsTab"
            @changeView="appelDeFondsTab = $event"
            class="is-border-bottom"></tabs>
          <program-appel-de-fonds-form
            v-if="selectedAppelDeFond"
            :steps="appelDeFondSteps"
            :selected="selectedAppelDeFond"
            :adf-documents="adfDocuments"
            @update="updateAppelDeFond($event)"
            @updateAdfDocument="updateMiscDocuments($event)"></program-appel-de-fonds-form>
        </div>
        <submit-sticky-buttons
          @submit="submit"
          :loading="submitLoading"
          button-id="programForm"></submit-sticky-buttons>
      </form>
    </div>
  </page-content>
</template>

<script>
import moment from 'moment'
import showdown from 'showdown'
import ProgramMixin from './ProgramMixin'
import { mapGetters, mapState } from 'vuex'
import { uniq, flatten, cloneDeep } from 'lodash'
import { PERMIS_TYPE } from '../../mixins/DefaultValues'
import TiersLink from '@/components/tiers/TiersLinkMixin'

export default {
  name: 'ProgramForm',
  components: {
    TagInput: () => import('@/components/utils/form/TagInput'),
    ProgramAppelDeFondsForm: () => import('./AppelDeFonds/ProgramAppelDeFondsForm'),
    ProgramBuildingLots: () => import('./ProgramBuildingLots'),
    TiersSelector: () => import('@/components/tiers/TiersSelector')
  },
  mixins: [ProgramMixin, TiersLink],
  data () {
    return {
      selectedNotaire: null,
      selectedGeometre: null,
      selectedArchitecte: null,
      createProgPath: false,
      editLotPath: false,
      programLoading: false,
      lotLoading: false,
      selectedRow: null,
      useCustomContract: null,
      tranchesToDelete: [],
      promoteur_custom_picture: [],
      panel: 'ADMINISTRATIF',
      newProgram: false,
      loadingAccount: false,
      formMode: true,
      promoteur: [],
      promoteurs: [],
      agences: [],
      allAgences: [],
      statusHelperText: null,
      hasCheck: false,
      hasReturnAdv: false,
      documentContratSelectedRow: null,
      deliveryYear: null,
      deliveryQuarter: null,
      actabilityYear: null,
      actabilityQuarter: null,
      startWorkYear: null,
      startWorkQuarter: null,
      endWorkYear: null,
      endWorkQuarter: null,
      buildingsToDelete: [],
      quarters: [
        { 1: '1er trimestre' },
        { 2: '2eme trimestre' },
        { 3: '3eme trimestre' },
        { 4: '4eme trimestre' }
      ],
      programFicheTab: 'FICHE_DESCRIPTIVE',
      programFicheTabs: [
        { label: 'Fiche descriptive', link: 'FICHE_DESCRIPTIVE' },
        { label: 'Paramètres d\'affichage', link: 'PARAMETRE' }
      ],
      documentsTab: 'DOCUMENTS',
      // Start at 1 to avoid "is-active" tab error
      appelDeFondsTab: 1,
      loading: false,
      scrollSale: false,
      isSage: null
    }
  },
  computed: {
    ...mapGetters(['isDistributeur', 'canUseBuyerSpace', 'canUseElectronicSign']),
    ...mapState(['currentUser', 'modal']),
    years () {
      let years = []
      let currentYear = moment().format('YYYY')
      for (let i = Number(currentYear) - 5; i < Number(currentYear) + 13; i++) years.push(i)
      return years
    },
    statusHelperId () {
      if (!this.program || !this.program.status) return null
      let IDS = {
        archived: 'zLynaCi2aWaUMuGIcwaqg',
        draft: '1EkcUUvtyI6oaAmmq6UWok',
        available: '4ncpu5K3ks66cO8wmo8EYC',
        private: '7EaDxyrfNY0MgcIo66o0Sq'
      }
      return IDS[this.program.status]
    },
    permisTypes () {
      return Object.values(PERMIS_TYPE)
    },
    appelDeFondsTabs () {
      if (this.program && this.program.tranches && this.program.tranches.length && this.program.use_tranche) {
        return [
          { link: 1, label: this.nameToUse },
          ...this.program.tranches.slice().sort((a, b) => {
            return a.label - b.label
          }).map((tranche, i) => {
            return { link: i + 2, label: tranche.name }
          })
        ]
      } else if (this.program && this.program.buildings && this.program.buildings.length) {
        return [
          { link: 1, label: this.nameToUse },
          ...this.program.buildings.slice().sort((a, b) => {
            return a.label - b.label
          }).map((building, i) => {
            return { link: i + 2, label: building.name }
          })
        ]
      } else if (this.program) {
        return [{ link: 1, label: this.nameToUse }]
      } else return []
    },
    appelDeFond () {
      if (this.program && this.program.tranches && this.program.tranches.length && this.program.use_tranche) {
        return [{
          programAdf: true,
          construction_steps: this.program.construction_steps,
          name: this.program.name,
          pk: this.program.pk
        }, ...this.program.tranches]
      } else if (this.program && this.program.buildings && this.program.buildings.length) {
        return [{
          programAdf: true,
          construction_steps: this.program.construction_steps,
          name: this.program.name,
          pk: this.program.pk
        }, ...this.program.buildings]
      } else if (this.program) {
        return [{
          programAdf: true,
          construction_steps: this.program.construction_steps,
          name: this.program.name,
          pk: this.program.pk
        }]
      } else return null
    },
    selectedAppelDeFond () {
      if (this.program) {
        if (this.appelDeFond[this.appelDeFondsTab - 1] && this.appelDeFond[this.appelDeFondsTab - 1].construction_steps) {
          return this.appelDeFond[this.appelDeFondsTab - 1]
        }
      }
      return null
    },
    appelDeFondSteps () {
      if (this.selectedAppelDeFond) {
        return this.selectedAppelDeFond.construction_steps
      } else return null
    },
    adfDocuments () {
      let documents = []
      if (this.program && this.program.misc_documents && this.program.misc_documents.length) {
        this.program.misc_documents.forEach(x => {
          if (x.destination && x.destination.length) {
            x.destination.forEach(y => {
              if (/step-/.test(y)) documents.push(x)
            })
          }
        })
      }
      return documents
    },
    documentsTabs () {
      const docs = [
        {
          label: `TOUS LES DOCUMENTS (${this.allDocumentList.length || 0})`,
          link: 'DOCUMENTS',
          class: 'is-size-6'
        },
        {
          label: `PROGRAMME (Visible par les prescripteurs) (${this.programDocumentList.length || 0})`,
          link: 'PROGRAMME',
          class: 'is-size-6'
        },
        {
          label: `DOSSIER DE RÉSERVATION (Annexé au contrat) (${this.dossierReservationDocumentList.length || 0})`,
          link: 'DOSSIER_RESERVATION',
          class: 'is-size-6'
        }
      ]
      if (this.canUseBuyerSpace) {
        docs.push({
          label: `ESPACE ACQUÉREUR (Tous les clients) (${this.espaceAcquereurDocumentList.length || 0})`,
          link: 'ESPACE_ACQUEREUR',
          class: 'is-size-6'
        })
      }
      return docs
    },
    programDestinations () {
      const destinations = {
        program: { label: 'Fiche ' + this.nameToUse, key: 'program', enabled: true },
        brochure: { label: 'Plaquette', key: 'brochure', enabled: false },
        contrat_reservation: { label: 'Contrat de réservation', key: 'contrat_reservation', enabled: false },
        reservation: { label: 'Dossier de réservation', key: 'reservation', enabled: true },
        buyer_space: { label: 'Espace acquéreur', key: 'buyer_space', enabled: false }
      }
      if (this.canUseBuyerSpace) {
        destinations.buyer_space.enabled = true
      }
      return Object.values(destinations)
    },
    allDocumentList () {
      return this.program.documents
    },
    programDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('program')
      })
    },
    dossierReservationDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('reservation')
      })
    },
    espaceAcquereurDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('buyer_space')
      })
    },
    documentsToDisplay () {
      if (this.documentsTab === 'PROGRAMME') return this.programDocumentList
      else if (this.documentsTab === 'DOSSIER_RESERVATION') return this.dossierReservationDocumentList
      else if (this.documentsTab === 'ESPACE_ACQUEREUR') return this.espaceAcquereurDocumentList
      else return this.allDocumentList
    },
    unavailableDispositifs  () {
      let dispos = this.programLots.map(lot => lot.tax_dispositifs)
      dispos = flatten(dispos)
      dispos = uniq(dispos)
      for (let dispo of dispos) {
        if (!this.program.tax_dispositifs.includes(dispo)) {
          const index = dispos.indexOf(dispo)
          if (index > -1) {
            dispos.splice(index, 1)
          }
        }
      }
      return dispos
    },
    internVisible () {
      return this.program.intern_visibility
    },
    externVisible () {
      return this.program.extern_visibility
    },
    isProgram () {
      return Object.keys(this.$route.params)
    },
    isLot () {
      return Object.keys(this.$route.params)
    },
    filteredOperationTypeList () {
      return this.OperationTypeList.filter(x => !x.hide)
    },
    isSageConnector () {
      return this.program.promoteur.sage_connector
    },
    dispositifs () {
      const dispositifs = this.taxDispositifsList.filter((x) => x.show.includes('program'))
      return dispositifs
    }
  },
  watch: {
    program (v) {
      if (v && !this.scrollSale) {
        this.scrollSale = true
        setTimeout(() => {
          this.setViewToTop()
        }, 100)
      }
    },
    'program.use_tranche' (v) {
      if (v) {
        this.setBuildingByTranche()
      }
    },
    'panel' () {
      this.setViewToTop()
    },
    'program.status' () {
      this.updateHelperText()
    },
    'program.is_amenagement' (v) {
      if (v === true) {
        return this.editLotInit()
      }
    },
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'CONTRACT_SELECT_MODAL') {
          this.program.contracts = results
        }
      }
    }
  },
  created () {
    if ('check' in this.$route.query) {
      this.hasCheck = true
    }
    if ('returnAdv' in this.$route.query) {
      this.hasReturnAdv = true
    }
    if ('panel' in this.$route.query) {
      this.panel = this.$route.query.panel
    }
    if (this.newProgram) {
      this.getCurrentPromoteur()
    }
    if (this.isLot.length !== 0) {
      this.lotLoading = true
    }
    if (this.isProgram.length === 0) {
      this.programLoading = true
    }
    if (this.$route.name === 'ProgramEdit') {
      this.createProgPath = true
    }
    // if (this.program.is_amenagement === true) {
    //   this.editLotPath = true
    // }
  },
  mounted () {
    // setTimeout(() => {
    //   this.setViewToTop()
    // }, 200)
  },
  methods: {
    /**
     * Sélection d'un notaire du référentiel : lie et remplit les champs
     * @param {object} interlocuteur - { ...interlocuteur, tiers }
     */
    selectNotaire (interlocuteur) {
      this.selectedNotaire = interlocuteur
      this.applyTiersSelection(this.writeNotaire, interlocuteur)
    },
    /**
     * Délier du référentiel : vide aussi les champs (anti-doublon)
     */
    unlinkNotaire () {
      this.selectedNotaire = null
      this.applyTiersUnlink(this.writeNotaire)
    },
    /**
     * writer(key, value) du bloc notaire de l'opération
     */
    writeNotaire (key, value) {
      this.updateValue(value, 'notary_data', key)
    },
    /**
     * Sélection d'un géomètre du référentiel : lie et remplit les champs
     * @param {object} interlocuteur - { ...interlocuteur, tiers }
     */
    selectGeometre (interlocuteur) {
      this.selectedGeometre = interlocuteur
      this.applyTiersSelection(this.writeGeometre, interlocuteur)
    },
    /**
     * Délier du référentiel : vide aussi les champs (anti-doublon)
     */
    unlinkGeometre () {
      this.selectedGeometre = null
      this.applyTiersUnlink(this.writeGeometre)
    },
    /**
     * writer(key, value) du bloc géomètre
     */
    writeGeometre (key, value) {
      this.updateValue(value, 'geometrician_data', key)
    },
    /**
     * Sélection d'un architecte du référentiel : lie et remplit les champs
     * @param {object} interlocuteur - { ...interlocuteur, tiers }
     */
    selectArchitecte (interlocuteur) {
      this.selectedArchitecte = interlocuteur
      this.applyTiersSelection(this.writeArchitecte, interlocuteur)
    },
    /**
     * Délier du référentiel : vide aussi les champs (anti-doublon)
     */
    unlinkArchitecte () {
      this.selectedArchitecte = null
      this.applyTiersUnlink(this.writeArchitecte)
    },
    /**
     * writer(key, value) du bloc architecte coordinateur
     */
    writeArchitecte (key, value) {
      this.updateValue(value, 'architect_data', key)
    },
    updateTrancheTrimester (value, trancheIndex, key) {
      const tranche = this.program.tranches[trancheIndex]
      if (tranche) {
        if (tranche[key] == null) {
          tranche[key] = '00000'
        }
        const year = tranche[key].toString().slice(0, 4)
        tranche[key] = `${year}${parseInt(value)}`
      }
    },
    updateTrancheYear (value, trancheIndex, key) {
      const tranche = this.program.tranches[trancheIndex]
      if (tranche) {
        if (tranche[key] == null) {
          tranche[key] = '00000'
        }
        const trimester = tranche[key].toString().slice(4, 5)
        tranche[key] = `${parseInt(value)}${trimester}`
      }
    },
    cancelChoice (v) {
      if (this.program.progress_step === v) {
        this.program.progress_step = null
      }
    },
    addNewPermis () {
      const emptyPermis = {
        numero: null,
        permis_type: null,
        date_deposit: null,
        date_obtaining: null,
        date_purge: null
      }
      if (!this.program.permis) this.program.permis = []
      this.program.permis.push(emptyPermis)
    },
    editLotInit () {
      this.editLotPath = true
      this.createProgPath = false
    },
    setViewToTop () {
      this.$nextTick(function () {
        var container = document.querySelector('#app')
        if (container) {
          container.scrollTo(0, 0)
        }
      })
    },
    /** Assign uploaded and cropped files to promoter model.
     *  @param {Object[]} file cloudinary file array
     *  @param {string} target target property on promoter's object
     *  @param {string} referentIndex referent index to update
     */
    uploadFile ({ file, referentIndex = null }) {
      file = file[0]
      this.program.referents[referentIndex].picture = [{ ...file }]
    },
    /** Delete files from promoter model.
     *  @see uploadFile for further information.
    */
    deleteFile (index = null, target) {
      this.program[target][index].picture = []
    },
    /**
      * delete program promoteur custom picture
      */
    deleteProgramParamsPicture () {
      this.promoteur_custom_picture = []
      this.program.program_params.promoteur_custom_picture = null
    },
    /**
      * set program promoteur custom picture
      * @param {array} files - array of picture
      */
    uploadPictures (files) {
      this.promoteur_custom_picture = [files[0]]
      this.program.program_params.promoteur_custom_picture = files[0]
    },
    /**
       * Use that method for non assignment or dom update issue (for red check for exemple)
       * @param { any } value - new value to assign
       * @param { String } key - primary key in program object
       * @param { String } secondaryKey - for deep assignment, key in program[key] object
       */
    updateValue (value, key, secondaryKey) {
      if (secondaryKey) {
        this.$set(this.program[key], secondaryKey, value)
      } else {
        this.$set(this.program, key, value)
      }
    },
    initProgramForm () {
      if (this.program.buildings && this.program.buildings.length) this.getProgramBuildings()
      if (this.program.tranches && this.program.tranches.length && this.program.use_tranche) this.getProgramTranches()
      if (!this.program.certifications || !Array.isArray(this.program.certifications)) this.program.certifications = []
      this.deliveryYear = this.program.date_livraison ? this.program.date_livraison.toString().substring(0, 4) : null
      this.deliveryQuarter = this.program.date_livraison ? this.program.date_livraison.toString().substring(4, 5) : null
      this.actabilityYear = this.program.date_actabilite ? this.program.date_actabilite.toString().substring(0, 4) : null
      this.actabilityQuarter = this.program.date_actabilite ? this.program.date_actabilite.toString().substring(4, 5) : null
      this.startWorkYear = this.program.construction_data.debut_travaux ? this.program.construction_data.debut_travaux.toString().substring(0, 4) : null
      this.startWorkQuarter = this.program.construction_data.debut_travaux ? this.program.construction_data.debut_travaux.toString().substring(4, 5) : null
      this.endWorkYear = this.program.construction_data.fin_travaux ? this.program.construction_data.fin_travaux.toString().substring(0, 4) : null
      this.endWorkQuarter = this.program.construction_data.fin_travaux ? this.program.construction_data.fin_travaux.toString().substring(4, 5) : null
      if (this.program.contract_in_use) {
        this.useCustomContract = this.program.contract_in_use
      }
    },
    beforeSubmit (program) {
      let missingField = []
      const noDecimalVariables = [
        { variable: program.construction_data.total_lots, label: 'Nombre total de logements' },
        { variable: program.construction_data.total_parking, label: 'Nombre total de parkings' }
      ]
      for (const { variable, label } of noDecimalVariables) {
        if (variable !== null && variable !== undefined && !/^\d+$/.test(variable.toString())) {
          this.$toasted.global.danger(`Le ${label} doit être un nombre entier.`)
          this.submitLoading = false
          return
        }
      }
      let surfacePlancher = program.construction_data.surface_plancher
      if (surfacePlancher && !/^(\d*\.\d{1,2}|\d+)$/.test(surfacePlancher)) {
        this.$toasted.global.danger(`La surface du plancher ne peut pas avoir plus de deux chiffres après la virgule.`)
        this.submitLoading = false
        return
      }
      if (program.permis && program.permis.length) {
        program.permis.forEach(p => {
          if (!p.permis_type) {
            if (!missingField.includes('Type de permis')) missingField.push('Type de permis')
          }
        })
      }
      if (program.referents && program.referents.length) {
        program.referents.forEach(p => {
          if (!p.phone && !p.email) {
            if (!missingField.includes('Contact référent')) missingField.push('Contact référent')
          }
        })
      }
      if (!program.address) missingField.push('address')
      if (!program.name) missingField.push('name')
      if (missingField.length) {
        this.$toasted.global.danger(`Veuillez renseigner les champs obligatoires (${missingField}).`)
        this.submitLoading = false
      } else {
        if (program.address && program.address.city) {
          program.address.city = program.address.city.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        }
        program.date_livraison = this.deliveryYear ? `${this.deliveryYear}${this.deliveryQuarter || '1'}` : null
        program.date_actabilite = this.actabilityYear ? `${this.actabilityYear}${this.actabilityQuarter || '1'}` : null
        program.promoteur = this.promoteur
        program.main_agence = program.main_agence ? program.main_agence.pk : null
        program.construction_data.debut_travaux = this.startWorkYear ? `${this.startWorkYear}${this.startWorkQuarter || '1'}` : null
        program.construction_data.fin_travaux = this.endWorkYear ? `${this.endWorkYear}${this.endWorkQuarter || '1'}` : null
        if (program.guaranteed_participation_fund === '') program.guaranteed_participation_fund = null
        if (program.fences_realisation === '') program.fences_realisation = null
        if (program.suez_installation === '') program.suez_installation = null
        program.contract_in_use = this.useCustomContract
        if (program.guaranteed_participation_fund === '') program.guaranteed_participation_fund = null
        if (program.fences_realisation === '') program.fences_realisation = null
        if (program.suez_installation === '') program.suez_installation = null
        return program
      }
    },
    async submit () {
      this.submitLoading = true
      const program = await this.beforeSubmit(this.program)
      if (program) {
        if (!this.newProgram) {
          this.submitProgramBuildingsAndTranches()
        }
        this.$emit('submit', program)
      }
    },
    submitProgramBuildingsAndTranches () {
      this.buildingsToDelete.forEach((building, i) => this.removeProgramBuilding(building, i, true))
      this.tranchesToDelete.forEach((tranche, i) => this.removeProgramTranche(tranche, i, true))
      if (this.program.tranches && this.program.tranches.length && this.program.use_tranche) {
        let allTrancheBuildings = 0
        for (let tranche of this.program.tranches) {
          allTrancheBuildings = allTrancheBuildings + tranche.buildings.length
        }
        this.program.tranches.filter(x => !x.pk).forEach(tranche => this.createProgramBuildingInTranche(tranche))
        // this.program.tranches.filter(x => x.pk && (x.adf_building_updated || x.building_updated || this.program.buildings.length !== allTrancheBuildings)).forEach(tranche => this.saveProgramTranche(tranche))
        this.program.tranches.filter(x => x.pk).forEach(tranche => this.saveProgramTranche(tranche))
      }
      if (this.program.buildings && this.program.buildings.length) {
        // create new building if no pk
        this.program.buildings.filter(x => !x.pk).forEach(building => this.addProgramBuilding(building, true))
        // save building if adf (appels de fonds) or name edited
        this.program.buildings.filter(x => x.pk && (x.adf_building_updated || x.building_updated)).forEach(building => this.saveProgramBuilding(building))
      }
    },
    updateAddress (address, target = 'address') {
      let t = target.split('.')
      if (t.length > 1) {
        this.$set(this.program[t[0]], t[1], address)
      } else {
        this.$set(this.program, t[0], address)
      }
    },
    async getPromoteurs (query) {
      try {
        const { data } = await this.$api.get(this.$resources.ACCOUNT, query)
        this.promoteurs = data.items
      } catch (e) {
        console.log(e)
      }
    },
    async getAgences (query) {
      try {
        if (!this.allAgences.length) {
          const { data } = await this.$api.get(this.$resources.AGENCE, { per_page: 200 })
          this.allAgences = data.items
        }
        // filtrage local insensible aux accents (ex : "beziers" doit trouver "Béziers")
        const norm = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        const q = query ? norm(query) : ''
        this.agences = q ? this.allAgences.filter(a => norm(a.name).includes(q)) : this.allAgences
      } catch (e) {
        console.log(e)
      }
    },
    updateHelperText () {
      this.statusHelperText = null
      if (this.program.status && this.statusHelperId && this.$contentful) {
        this.$contentful.getEntry(this.statusHelperId).then(entry => {
          let converter = new showdown.Converter()
          let text = entry.fields.text
          this.statusHelperText = converter.makeHtml(text)
        })
      }
    },
    async getProgramBuildings () {
      try {
        const { data } = await this.$api.get(this.$resources.PROGRAM_BUILDING(this.program.pk))
        this.$set(this.program, 'buildings', data.items)
        this.getProgramLots()
      } catch (e) {
        console.log(e)
      }
    },
    setBuildingByTranche () {
      if (this.program.tranches && this.program.tranches.length > 0) {
        for (let tranche of this.program.tranches) {
          tranche['buildings'] = []
          for (let building of this.program.buildings) {
            if (building.tranche === tranche.pk) {
              if ('buildings' in tranche) {
                tranche['buildings'].push(building)
              } else {
                tranche['buildings'] = []
                tranche['buildings'].push(building)
              }
            }
          }
        }
      }
    },
    async getProgramTranches () {
      try {
        const { data } = await this.$api.axios.get(`programs/${this.program.pk}/tranches`)
        for (let tranche of data.items) {
          if (!tranche.debut_travaux) tranche.debut_travaux = '00000'
          if (!tranche.fin_travaux) tranche.fin_travaux = '00000'
          if (!tranche.date_livraison) tranche.date_livraison = '00000'
          if (!tranche.date_actabilite) tranche.date_actabilite = '00000'
        }
        this.$set(this.program, 'tranches', data.items)
        this.setBuildingByTranche()
        this.getProgramLots()
      } catch (e) {
        console.log(e)
      }
    },
    async addProgramBuilding (building, submit = false) {
      if (submit) {
        try {
          await this.$api.post(this.$resources.PROGRAM_BUILDING(this.program.pk), building)
        } catch (e) {
          console.log(e)
        }
      } else {
        let building = { name: `Bâtiment ${this.program.buildings.length + 1}` }
        this.program.buildings.push(building)
      }
    },
    async addProgramBuildingInTranche (index = 0) {
      let building = { name: `Bâtiment ${this.program.tranches[index].buildings.length + 1}`, tranche: this.program.tranches[index].name }
      this.program.tranches[index].buildings.push(building)
      this.$forceUpdate()
    },
    async createProgramBuildingInTranche (tranche) {
      try {
        await this.$api.axios.post(`programs/${this.program.pk}/tranches/`, tranche)
      } catch (e) {
        console.log(e)
      }
    },
    async addProgramTranche () {
      let tranche = { name: `Tranche ${this.program.tranches.length + 1}`, buildings: [] }
      tranche.date_actabilite = '00000'
      tranche.date_livraison = '00000'
      tranche.debut_travaux = '00000'
      tranche.fin_travaux = '00000'
      tranche.gfa_defined_percentage = 50
      this.program.tranches.push(tranche)
    },
    async removeProgramBuilding (building, idx, submit = false) {
      if (submit) {
        try {
          await this.$api.delete(this.$resources.PROGRAM_BUILDING(this.program.pk), building.pk)
        } catch (e) {
          this.$toasted.global.danger('Erreur dans la suppression du bâtiment')
        }
      } else {
        try {
          let hasLots = false
          if (building.pk) {
            const { data } = await this.$api.get(this.$resources.LOT, { building: building.pk })
            hasLots = data.items.length
          }
          if (hasLots) {
            this.$toasted.global.danger('Un ou plusieurs lots sont rattachés à ce bâtiment, suppression impossible.')
          } else {
            this.program.buildings.splice(idx, 1)
            this.buildingsToDelete.push(building)
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    async removeProgramBuildingInTranche (building, idx, indexTranche) {
      try {
        let hasLots = false
        if (building.pk) {
          const { data } = await this.$api.get(this.$resources.LOT, { building: building.pk })
          if (data.items.length > 0) {
            hasLots = true
          }
        }
        if (hasLots) {
          this.$toasted.global.danger('Un ou plusieurs lots sont rattachés à ce bâtiment, suppression impossible.')
        } else {
          this.program.tranches[indexTranche].buildings.splice(idx, 1)
          let index = this.program.buildings.findIndex(x => x.pk === building.pk)
          if (index >= 0) {
            this.program.buildings.splice(index, 1)
          }
          this.$forceUpdate()
          this.buildingsToDelete.push(building)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async removeProgramTranche (tranche, idx, submit = false) {
      if (submit) {
        try {
          await this.$api.axios.delete(`/programs/${this.program.pk}/tranches/${tranche.pk}`)
        } catch (e) {
          this.$toasted.global.danger('Erreur dans la suppression du bâtiment')
        }
      } else {
        try {
          let hasLots = false
          for (let building of tranche.buildings) {
            if (building.pk) {
              const { data } = await this.$api.get(this.$resources.LOT, { building: building.pk })
              if (data.items.length > 0) {
                hasLots = true
              }
            }
          }
          if (hasLots) {
            this.$toasted.global.danger('Un ou plusieurs lots sont rattachés à un bâtiment de cette tranche, suppression impossible.')
          } else {
            this.program.tranches.splice(idx, 1)
            this.tranchesToDelete.push(tranche)
            for (let building of tranche.buildings) {
              this.buildingsToDelete.push(building)
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    async saveProgramBuilding (building) {
      if (!building.construction_data) building.construction_data = { planned_developments: null }
      try {
        await this.$api.patch(this.$resources.PROGRAM_BUILDING(this.program.pk), building.pk, building)
      } catch (e) {
        console.log(e)
      }
    },
    async saveProgramTranche (tranche) {
      for (const [key, value] of Object.entries(tranche)) {
        if (typeof value === 'string') {
          if (value.toString().substring(0, 4) === '0000' || value.toString().substring(4, 5) === '0') {
            tranche[key] = null
          }
        }
      }
      if (!tranche.construction_data) tranche.construction_data = { planned_developments: null }
      try {
        await this.$api.axios.patch(`programs/${this.program.pk}/tranches/${tranche.pk}`, tranche)
        for (let building of tranche.buildings) {
          let newBuilding = cloneDeep(tranche)
          newBuilding.name = building.name
          newBuilding.pk = building.pk
          newBuilding.tranche = building.tranche
          delete newBuilding.buildings
          await this.saveProgramBuilding(newBuilding)
        }
      } catch (e) {
        console.log(e)
      }
    },
    updateAppelDeFond (v) {
      if (v && v.programAdf) {
        this.program.construction_steps = v.construction_steps
        this.program.adf_updated = true
      } else {
        Object.assign(this.selectedAppelDeFond, { ...v, adf_building_updated: true })
      }
    },
    uploadOrder (v) {
      this.program.documents = v
    },
    uploadOrderPictures (v) {
      this.program.pictures = v
    },
    updateMiscDocuments (documents) {
      this.program.misc_documents = documents
    },
    async getCurrentPromoteur () {
      try {
        this.loadingAccount = true
        const { data } = await this.$api.getOne(this.$resources.ACCOUNT, this.currentUser.account.pk)
        this.program.promoteur_data = {
          company_name: data.name,
          reservant: null,
          rep_last_name: data.first_admin.last_name,
          rep_first_name: data.first_admin.first_name,
          rep_phone: data.phone,
          rep_email: data.email,
          rep_address: data.address
        }
        this.isSage = data.sage_connector
        this.loadingAccount = false
      } catch (e) {
        this.loadingAccount = false
        console.log(e)
      }
    }
  }
}
</script>

<style lang="sass">

.btn_style
  width: 260px
  min-height: 50px

.btn-export
  width: 100%
  min-height: 100% !important
  font-size: 1.2rem
  display: flex
</style>
